import React from 'react';
import {IntlProvider, FormattedMessage, useIntl} from 'react-intl';

import {
  FormGroup,
  FormField,
  Input,
  Dropdown,
  Checkbox
} from 'semantic-ui-react'

const CardPatientInfoREGUX = (props: any) => {
    return(
      <div
        id="CardPatientInfoREGUX-div-0"
        style={{ width: "100%", height: "100%" ,padding: "10px"}}>
        <div
          id="CardPatientInfoREGUX-div-1"
          style={{ display: "flex", alignItems: "center" }}>
          
          <div
            id="CardPatientInfoREGUX-div-2"
            style={{marginBottom: "0.5rem", fontSize: "1.2rem", fontWeight: "bold"}}>
            {props.languageUX === "en" ? "Patient history" : "ประวัติผู้ป่วย"}
          </div>
          <div
            id="CardPatientInfoREGUX-div-157"
            style={{ margin: "0px 15px" }}>
            {props.buttonVerify}
          </div>
          <div
            id="CardPatientInfoREGUX-div-181">
            {props.onMergePatientBtn}
          </div>
        </div>
        <div
          className="ui form"
          id="CardPatientInfoREGUX-div-3">
          
          <FormGroup
            id="CardPatientInfoREGUX-FormGroup-4"
            inline={true}>
            <FormField
              id="CardPatientInfoREGUX-FormField-5"
              inline={true}
              width={5}>
              <label
                id="CardPatientInfoREGUX-label-13"
                style={{textAlign: "right", width: "100%", fontWeight: "normal"}}>
                {props.languageUX === "en" ? "HN of the original system" : "HN ของระบบเดิม"}
              </label>
            </FormField>
            <FormField
              id="CardPatientInfoREGUX-FormField-6"
              inline={true}
              width={5}>
              <Input
                disabled={true}
                fluid={true}
                id="CardPatientInfoREGUX-Input-11">
              </Input>
            </FormField>
            <FormField
              className="required"
              id="CardPatientInfoREGUX-FormField-8"
              inline={true}
              width={6}>
              <label
                id="CardPatientInfoREGUX-label-15"
                style={{minWidth: "max-content", fontWeight: "normal", color: "red"}}>
                {props.languageUX === "en" ? "Information channels" : "ช่องทางให้ข้อมูล"}
              </label>
              <Dropdown
                clearable={true}
                fluid={true}
                id="cb-infoChanel"
                onChange={props.changeProp("info_channel")}
                options={props.masterOptions?.infoChannel}
                selection={true}
                style={{width: "100%"}}
                value={props.patient?.info_channel}>
              </Dropdown>
            </FormField>
          </FormGroup>
          <FormGroup
            id="CardPatientInfoREGUX-FormGroup-16"
            inline={true}
            style={{display: "none"}}>
            <FormField
              id="CardPatientInfoREGUX-FormField-17"
              inline={true}
              width={5}>
              <label
                id="CardPatientInfoREGUX-label-19"
                style={{fontWeight: "normal"}}>
                {props.languageUX === "en" ? "Concealment of patient data" : "การปกปิดข้อมูลผู้ป่วย / Concealment of patient data"}
              </label>
            </FormField>
            <FormField
              id="CardPatientInfoREGUX-FormField-18"
              inline={true}
              width={5}>
              <Dropdown
                clearable={true}
                fluid={true}
                id="cb-conceal"
                onChange={props.changeProp("is_secret")}
                options={props.secretOptions}
                search={true}
                selection={true}
                style={{width: "100%"}}
                value={props.patient?.is_secret}>
              </Dropdown>
            </FormField>
          </FormGroup>
          <FormGroup
            id="CardPatientInfoREGUX-FormGroup-21">
            <FormField
              className="required"
              id="CardPatientInfoREGUX-FormField-22"
              width={5}>
              <label
                id="CardPatientInfoREGUX-label-24"
                style={{fontWeight: "normal", color: "red"}}>
                {props.languageUX === "en" ? "National Identification Number" : "เอกสารระบุตัวตน / National Identification number"}
              </label>
              <Dropdown
                clearable={true}
                fluid={true}
                id="cb-identify"
                onChange={props.changeProp("citizen_type")}
                options={props.citizenTypeOptions}
                search={true}
                selection={true}
                style={{width: "100%"}}
                value={props.patient?.citizen_type}>
              </Dropdown>
            </FormField>
            <FormField
              className={props.citizenLable ? "required" : ""}
              id="CardPatientInfoREGUX-FormField-23"
              width={6}>
              <label
                id="CardPatientInfoREGUX-label-25"
                style={{fontWeight: "normal", color: "red"}}>
                {props.citizenLable || "\u00a0"}
              </label>
              <div
                id="CardPatientInfoREGUX-div-136"
                style={{width: "100%"}}>
                {props.citizenInput}
              </div>
            </FormField>
            <FormField
              id="CardPatientInfoREGUX-FormField-138"
              width={4}>
              <label
                id="CardPatientInfoREGUX-label-139"
                style={{fontWeight: "normal"}}>
                {props.reimburseLabel|| "\u00a0"}
              </label>
              <div
                id="CardPatientInfoREGUX-div-140">
                {props.reimburseInput}
              </div>
            </FormField>
            <FormField
              id="CardPatientInfoREGUX-FormField-28">
              <label
                id="CardPatientInfoREGUX-label-30">
                {"\u00a0"}
              </label>
              <div
                id="CardPatientInfoREGUX-div-141">
                {props.nonResidentChk}
              </div>
            </FormField>
          </FormGroup>
          <FormGroup
            id="CardPatientInfoREGUX-FormGroup-31">
            <FormField
              className={(props.patient?.citizen_type === "" || props.patient?.citizen_type === "T") && "required"}
              id="CardPatientInfoREGUX-FormField-32"
              width={3}>
              <label
                id="CardPatientInfoREGUX-label-36"
                style={{fontWeight: "normal", ...(  (props.patient?.citizen_type === "" || props.patient?.citizen_type === "T") && {  color: "red" } )}}>
                {props.languageUX === "en" ? "Prefix (TH)" : "คำนำหน้า"}
              </label>
              <Dropdown
                clearable={true}
                compact={true}
                fluid={true}
                id="cb-prefix"
                onChange={props.changeProp("pre_name_th")}
                options={props.masterOptions?.prenameTh}
                search={true}
                selection={true}
                style={{width: "100%"}}
                value={props.patient?.pre_name_th}>
              </Dropdown>
            </FormField>
            <FormField
              className={(props.patient?.citizen_type === "" || props.patient?.citizen_type === "T") && "required"}
              id="CardPatientInfoREGUX-FormField-33"
              width={4}>
              <label
                id="CardPatientInfoREGUX-label-37"
                style={{fontWeight: "normal", ...(  (props.patient?.citizen_type === "" || props.patient?.citizen_type === "T") && {  color: "red" } )}}>
                {props.languageUX === "en" ? "First name (TH)" : "ชื่อ"}
              </label>
              <Input
                fluid={true}
                id="txt-firstName"
                onChange={props.changeProp("first_name_th")}
                style={{width: "100%"}}
                value={props.patient?.first_name_th}>
              </Input>
            </FormField>
            <FormField
              className={(props.patient?.citizen_type === "" || props.patient?.citizen_type === "T") && "required"}
              id="CardPatientInfoREGUX-FormField-34"
              width={4}>
              <label
                id="CardPatientInfoREGUX-label-38"
                style={{fontWeight: "normal", ...(  (props.patient?.citizen_type === "" || props.patient?.citizen_type === "T") && {  color: "red" } )}}>
                {props.languageUX === "en" ? "Last name (TH)" : "นามสกุล"}
              </label>
              <Input
                fluid={true}
                id="txt-lastName"
                onChange={props.changeProp("last_name_th")}
                style={{width: "100%"}}
                value={props.patient?.last_name_th}>
              </Input>
            </FormField>
            <FormField
              id="CardPatientInfoREGUX-FormField-35"
              width={4}>
              <label
                id="CardPatientInfoREGUX-label-39"
                style={{fontWeight: "normal"}}>
                {props.languageUX === "en" ? "Middle name (TH)" : "ชื่อกลาง"}
              </label>
              <Input
                fluid={true}
                id="CardPatientInfoREGUX-Input-43"
                onChange={props.changeProp("middle_name_th")}
                style={{width: "100%"}}
                value={props.patient?.middle_name_th}>
              </Input>
            </FormField>
          </FormGroup>
          <FormGroup
            id="CardPatientInfoREGUX-FormGroup-44">
            <FormField
              className={(props.patient?.citizen_type !== "" && props.patient?.citizen_type !== "T") && "required"}
              id="CardPatientInfoREGUX-FormField-45"
              inline={true}
              width={3}>
              <label
                id="CardPatientInfoREGUX-label-177"
                style={{fontWeight: "normal", ...(  (props.patient?.citizen_type !== "" && props.patient?.citizen_type !== "T") && {  color: "red" } )}}>
                {props.languageUX === "en" ? "Prefix" : "Prefix"}
              </label>
              <Dropdown
                clearable={true}
                compact={true}
                fluid={true}
                onChange={props.changeProp("pre_name_en")}
                options={props.masterOptions?.prenameEn}
                search={true}
                selection={true}
                style={{width: "100%"}}
                value={props.patient?.pre_name_en}>
              </Dropdown>
            </FormField>
            <FormField
              className={(props.patient?.citizen_type !== "" && props.patient?.citizen_type !== "T") && "required"}
              id="CardPatientInfoREGUX-FormField-46"
              inline={true}
              width={4}>
              <label
                id="CardPatientInfoREGUX-label-178"
                style={{fontWeight: "normal", ...(  (props.patient?.citizen_type !== "" && props.patient?.citizen_type !== "T") && {  color: "red" } )}}>
                {props.languageUX === "en" ? "First name" : "First name"}
              </label>
              <Input
                fluid={true}
                id="CardPatientInfoREGUX-Input-50"
                onChange={props.changeProp("first_name_en")}
                style={{width: "100%"}}
                value={props.patient?.first_name_en}>
              </Input>
            </FormField>
            <FormField
              className={(props.patient?.citizen_type !== "" && props.patient?.citizen_type !== "T") && "required"}
              id="CardPatientInfoREGUX-FormField-47"
              inline={true}
              width={4}>
              <label
                id="CardPatientInfoREGUX-label-179"
                style={{fontWeight: "normal", ...(  (props.patient?.citizen_type !== "" && props.patient?.citizen_type !== "T") && {  color: "red" } )}}>
                {props.languageUX === "en" ? "Last name" : "Last name"}
              </label>
              <Input
                fluid={true}
                id="CardPatientInfoREGUX-Input-51"
                onChange={props.changeProp("last_name_en")}
                style={{width: "100%"}}
                value={props.patient?.last_name_en}>
              </Input>
            </FormField>
            <FormField
              id="CardPatientInfoREGUX-FormField-48"
              inline={true}
              width={4}>
              <label
                id="CardPatientInfoREGUX-label-180"
                style={{fontWeight: "normal", }}>
                {props.languageUX === "en" ? "Middle name" : "Middle name"}
              </label>
              <Input
                id="CardPatientInfoREGUX-Input-52"
                onChange={props.changeProp("middle_name_en")}
                style={{width: "100%"}}
                value={props.patient?.middle_name_en}>
              </Input>
            </FormField>
          </FormGroup>
          <FormGroup
            id="CardPatientInfoREGUX-FormGroup-53"
            inline={true}>
            <FormField
              id="CardPatientInfoREGUX-FormField-54"
              inline={true}>
              <label
                id="CardPatientInfoREGUX-label-57"
                style={{minWidth: "80px", maxWidth: "80px",fontWeight: "normal", color: "red"}}>
                {props.languageUX === "en" ? "Gender/Gender*" : "เพศ / Gender*"}
              </label>
            </FormField>
            <FormField
              id="CardPatientInfoREGUX-FormField-55"
              inline={true}
              width={3}>
              <Dropdown
                clearable={true}
                compact={true}
                fluid={true}
                id="cb-gender"
                onChange={props.changeProp("gender")}
                options={props.masterOptions?.gender}
                search={true}
                selection={true}
                style={{width: "100%"}}
                value={props.patient?.gender}>
              </Dropdown>
            </FormField>
            <FormField
              className="required"
              id="CardPatientInfoREGUX-FormField-56"
              inline={true}>
              <label
                id="CardPatientInfoREGUX-label-61"
                style={{fontWeight: "normal", color: "red"}}>
                {props.languageUX === "en" ? "Blood type" : "หมู่เลือด / Blood type"}
              </label>
            </FormField>
            <FormField
              id="CardPatientInfoREGUX-FormField-59"
              inline={true}
              width={2}>
              <Dropdown
                clearable={true}
                compact={true}
                fluid={true}
                id="cb-blood"
                onChange={props.changeProp("blood_type")}
                options={props.masterOptions?.bloodType}
                search={true}
                selection={true}
                style={{width: "100%"}}
                value={props.patient?.blood_type}>
              </Dropdown>
            </FormField>
          </FormGroup>
          <FormGroup
            id="CardPatientInfoREGUX-FormGroup-62"
            inline={true}>
            <FormField
              className="required"
              id="CardPatientInfoREGUX-FormField-120"
              inline={true}
              width={5}>
              <label
                id="CardPatientInfoREGUX-label-124"
                style={{minWidth: "80px", maxWidth: "80px",fontWeight: "normal", color: "red"}}>
                {props.languageUX === "en" ? "Date of birth" : "วันเดือนปีเกิด date of birth"}
              </label>
              <div
                id="CardPatientInfoREGUX-div-134"
                style={{width: "100%"}}>
                {props.dateTextBox}
              </div>
            </FormField>
            <FormField
              id="CardPatientInfoREGUX-FormField-121"
              inline={true}
              width={3}>
              <Checkbox
                checked={props.patient?.use_birthdate_special}
                id="CardPatientInfoREGUX-Checkbox-129"
                name="use_birthdate_special"
                onChange={props.changeBirthdateSpecial}>
              </Checkbox>
              <Dropdown
                disabled={!props.patient?.use_birthdate_special}
                fluid={true}
                id="CardPatientInfoREGUX-Dropdown-130"
                onChange={props.changeProp("birthdate")}
                options={[ {key: 1, value: "", text: "ไม่ระบุ"}, { key: 2, value: "28/02/2482", text: "29/02/2482" }, { key: 3, value: "28/02/2478", text: "29/02/2478" }, { key: 4, value: "28/02/2474", text: "29/02/2474" }, { key: 5, value: "28/02/2470", text: "29/02/2470" }, { key: 6, value: "28/02/2466", text: "29/02/2466" }, { key: 7, value: "28/02/2462", text: "29/02/2462" }, { key: 8, value: "28/02/2458", text: "29/02/2458" }, { key: 9, value: "28/02/2454", text: "29/02/2454" }, { key: 10, value: "28/02/2450", text: "29/02/2450" }, { key: 11, value: "28/02/2446", text: "29/02/2446" }, { key: 12, value: "28/02/2442", text: "29/02/2442" } ]}
                search={true}
                selection={true}
                style={{width: "100%"}}
                value={props.patient?.use_birthdate_special ? props.patient?.birthdate : ""}>
              </Dropdown>
            </FormField>
            <FormField
              id="CardPatientInfoREGUX-FormField-122"
              inline={true}
              width={4}>
              <label
                id="CardPatientInfoREGUX-label-131"
                style={{minWidth: "max-content",fontWeight: "normal"}}>
                {props.languageUX === "en" ? "Age / Age" : "อายุ / Age"}
              </label>
              <div
                id="CardPatientInfoREGUX-div-135"
                style={{width: "100%"}}>
                {props.age}
              </div>
            </FormField>
            <FormField
              id="CardPatientInfoREGUX-FormField-123"
              inline={true}
              width={4}>
              <label
                id="CardPatientInfoREGUX-label-132"
                style={{minWidth: "50px",maxWidth: "50px",fontWeight: "normal"}}>
                {props.languageUX === "en" ? "Religion" : "ศาสนา / Religion"}
              </label>
              <Dropdown
                className="cb-nationality"
                clearable={true}
                fluid={true}
                id="CardPatientInfoREGUX-Dropdown-133"
                onChange={props.changeProp("religion_code")}
                options={props.masterOptions?.religion}
                search={true}
                selection={true}
                style={{width: "100%"}}
                value={props.patient?.religion_code}>
              </Dropdown>
            </FormField>
          </FormGroup>
          <FormGroup
            id="CardPatientInfoREGUX-FormGroup-63"
            inline={true}>
            <FormField
              id="CardPatientInfoREGUX-FormField-64"
              inline={true}
              width={5}>
              <label
                id="CardPatientInfoREGUX-label-67"
                style={{minWidth: "80px", maxWidth: "80px",fontWeight: "normal"}}>
                {props.languageUX === "en" ? "Country of birth / Birth country" : "ประเทศที่เกิด / Birth country"}
              </label>
              <Dropdown
                clearable={true}
                fluid={true}
                id="CardPatientInfoREGUX-Dropdown-70"
                onChange={props.changeProp("birth_country")}
                options={props.masterOptions?.country}
                search={true}
                selection={true}
                style={{width: "100%"}}
                value={props.patient?.birth_country}>
              </Dropdown>
            </FormField>
            <FormField
              id="CardPatientInfoREGUX-FormField-65"
              inline={true}
              width={6}>
              <label
                id="CardPatientInfoREGUX-label-68"
                style={{minWidth: "85px", maxWidth: "85px",fontWeight: "normal"}}>
                {props.languageUX === "en" ? "Birth place" : "จังหวัดที่เกิด / Birth place"}
              </label>
              <Dropdown
                clearable={true}
                fluid={true}
                id="CardPatientInfoREGUX-Dropdown-71"
                onChange={props.changeProp("birth_province")}
                options={props.masterOptions?.province}
                search={true}
                selection={true}
                style={{width: "100%"}}
                value={props.patient?.birth_province}>
              </Dropdown>
            </FormField>
            <FormField
              className="required"
              id="CardPatientInfoREGUX-FormField-66"
              inline={true}
              width={5}>
              <label
                id="CardPatientInfoREGUX-label-69"
                style={{minWidth: "85px", maxWidth: "85px",fontWeight: "normal", color: "red"}}>
                {props.languageUX === "en" ? "Nationality" : "สัญชาติ / Nationality"}
              </label>
              <Dropdown
                clearable={true}
                compact={true}
                fluid={true}
                id="txt-nationality"
                onChange={props.changeProp("nationality")}
                options={props.masterOptions?.nationality}
                search={true}
                selection={true}
                style={{width: "100%"}}
                value={props.patient?.nationality}>
              </Dropdown>
            </FormField>
          </FormGroup>
          <FormGroup
            id="CardPatientInfoREGUX-FormGroup-73"
            inline={true}>
            <FormField
              id="CardPatientInfoREGUX-FormField-75"
              inline={true}
              width={8}>
              <label
                id="CardPatientInfoREGUX-label-78"
                style={{minWidth: "80px", maxWidth: "80px",fontWeight: "normal"}}>
                {props.languageUX === "en" ? "Ethnicity" : "เชื้อชาติ / Ethnicity"}
              </label>
              <Dropdown
                clearable={true}
                fluid={true}
                id="CardPatientInfoREGUX-Dropdown-82"
                onChange={props.changeProp("race")}
                options={props.masterOptions?.race}
                search={true}
                selection={true}
                style={{width: "100%"}}
                value={props.patient?.race}>
              </Dropdown>
            </FormField>
            <FormField
              id="CardPatientInfoREGUX-FormField-79"
              inline={true}
              width={8}>
              <label
                id="CardPatientInfoREGUX-label-80"
                style={{width: "125px",fontWeight: "normal"}}>
                {props.languageUX === "en" ? "Belief" : "ความเชื่อ / Belief"}
              </label>
              <Dropdown
                clearable={true}
                fluid={true}
                id="CardPatientInfoREGUX-Dropdown-81"
                onChange={props.changeProp("belief")}
                options={props.masterOptions?.belief}
                search={true}
                selection={true}
                style={{width: "100%"}}
                value={props.patient?.belief}>
              </Dropdown>
            </FormField>
          </FormGroup>
          <FormGroup
            id="CardPatientInfoREGUX-FormGroup-83"
            inline={true}>
            <FormField
              id="CardPatientInfoREGUX-FormField-84"
              inline={true}
              width={5}>
              <label
                id="CardPatientInfoREGUX-label-87"
                style={{minWidth: "80px", maxWidth: "80px",fontWeight: "normal"}}>
                {props.languageUX === "en" ? "Occupation" : "อาชีพ / Occupation"}
              </label>
              <Dropdown
                clearable={true}
                fluid={true}
                id="CardPatientInfoREGUX-Dropdown-90"
                onChange={props.changeProp("career")}
                options={props.masterOptions?.career}
                search={true}
                selection={true}
                style={{width: "100%"}}
                value={props.patient?.career}>
              </Dropdown>
            </FormField>
            <FormField
              id="CardPatientInfoREGUX-FormField-85"
              inline={true}
              width={6}>
              <label
                id="CardPatientInfoREGUX-label-88"
                style={{minWidth: "85px", maxWidth: "85px",fontWeight: "normal"}}>
                {props.languageUX === "en" ? "Job Position / Position" : "ตำแหน่งงาน / Position"}
              </label>
              <Dropdown
                clearable={true}
                fluid={true}
                id="CardPatientInfoREGUX-Dropdown-91"
                onChange={props.changeProp("position")}
                options={props.masterOptions?.position}
                search={true}
                selection={true}
                style={{width: "100%"}}
                value={props.patient?.position}>
              </Dropdown>
            </FormField>
            <FormField
              id="CardPatientInfoREGUX-FormField-86"
              inline={true}
              width={5}>
              <label
                id="CardPatientInfoREGUX-label-89"
                style={{minWidth: "85px", maxWidth: "85px",fontWeight: "normal"}}>
                {props.languageUX === "en" ? "Education level / Education" : "ระดับการศึกษา / Education"}
              </label>
              <Dropdown
                clearable={true}
                fluid={true}
                id="CardPatientInfoREGUX-Dropdown-92"
                onChange={props.changeProp("education")}
                options={props.masterOptions?.education}
                search={true}
                selection={true}
                style={{width: "100%"}}
                value={props.patient?.education}>
              </Dropdown>
            </FormField>
          </FormGroup>
          <FormGroup
            id="CardPatientInfoREGUX-FormGroup-93"
            inline={true}>
            <FormField
              id="CardPatientInfoREGUX-FormField-96"
              inline={true}
              width={8}>
              <label
                id="CardPatientInfoREGUX-label-102"
                style={{minWidth: "80px", maxWidth: "80px",fontWeight: "normal"}}>
                {props.languageUX === "en" ? "Marital status" : "สถานภาพสมรส / Marital status"}
              </label>
              <Dropdown
                clearable={true}
                fluid={true}
                id="CardPatientInfoREGUX-Dropdown-105"
                onChange={props.changeProp("marriage")}
                options={props.marriageOptions}
                search={true}
                selection={true}
                style={{width: "100%"}}
                value={props.patient?.marriage}>
              </Dropdown>
            </FormField>
            <FormField
              id="CardPatientInfoREGUX-FormField-97"
              inline={true}
              width={8}>
              <label
                id="CardPatientInfoREGUX-label-106"
                style={{minWidth: "100px", maxWidth: "100px",fontWeight: "normal"}}>
                {props.languageUX === "en" ? "Spouse's Name" : "ชื่อคู่สมรส / Spouse's Name"}
              </label>
              <Input
                fluid={true}
                id="CardPatientInfoREGUX-Input-110"
                onChange={props.changeProp("couple")}
                style={{width: "100%"}}
                value={props.patient?.couple}>
              </Input>
            </FormField>
          </FormGroup>
          <FormGroup
            id="CardPatientInfoREGUX-FormGroup-94"
            inline={true}>
            <FormField
              className={props.isRequired && "required"}
              id="CardPatientInfoREGUX-FormField-98"
              inline={true}
              width={8}>
              <label
                id="CardPatientInfoREGUX-label-103"
                style={{minWidth: "80px", maxWidth: "80px",fontWeight: "normal", ...(props.isRequired && {color: "red"})}}>
                {props.languageUX === "en" ? "Father's Name" : "ชื่อบิดา / Father's Name"}
              </label>
              <Input
                fluid={true}
                id="txt-fatherName"
                onChange={props.changeProp("father")}
                style={{width: "100%"}}
                value={props.patient?.father}>
              </Input>
            </FormField>
            <FormField
              className={props.isRequired && "required"}
              id="CardPatientInfoREGUX-FormField-99"
              inline={true}
              width={8}>
              <label
                id="CardPatientInfoREGUX-label-107"
                style={{minWidth: "80px", maxWidth: "80px",fontWeight: "normal", ...(props.isRequired && {color: "red"})}}>
                {props.languageUX === "en" ? "Mother's Name" : "ชื่อมารดา / Mother's Name"}
              </label>
              <Input
                fluid={true}
                id="txt-motherName"
                onChange={props.changeProp("mother")}
                style={{width: "100%"}}
                value={props.patient?.mother}>
              </Input>
            </FormField>
          </FormGroup>
          <FormGroup
            id="CardPatientInfoREGUX-FormGroup-158"
            inline={true}>
            <FormField
              id="CardPatientInfoREGUX-FormField-159"
              inline={true}
              width={6}>
              <label
                id="CardPatientInfoREGUX-label-171"
                style={{minWidth: "80px", maxWidth: "150px",fontWeight: "normal", color: "red"}}>
                {props.languageUX === "en" ? "Emergency contact name / Emergency contact *" : "ชื่อผู้ติดต่อฉุกเฉิน / Emergency contact *"}
              </label>
              <Input
                fluid={true}
                onChange={props.changeProp("relative_address.owner_name")}
                style={{width: "100%"}}
                value={props.patient?.relative_address?.owner_name}>
              </Input>
            </FormField>
            <FormField
              id="CardPatientInfoREGUX-FormField-160"
              inline={true}
              width={6}>
              <label
                id="CardPatientInfoREGUX-label-172"
                style={{minWidth: "100px", maxWidth: "100px",fontWeight: "normal", color: "red"}}>
                {props.languageUX === "en" ? "Contact Number / Phone No. *" : "เบอร์โทรผู้ติดต่อ / Phone No. *"}
              </label>
              <Input
                fluid={true}
                onChange={props.changeProp("relative_address.tel_mobile")}
                style={{width: "100%"}}
                value={props.patient?.relative_address?.tel_mobile}>
              </Input>
            </FormField>
            <FormField
              id="CardPatientInfoREGUX-FormField-161"
              inline={true}
              width={4}>
              <label
                id="CardPatientInfoREGUX-label-173">
                {props.languageUX === "en" ? "Relationship / Relationship" : "ความสัมพันธ์ / Relationship"}
              </label>
              <Dropdown
                clearable={true}
                fluid={true}
                onChange={props.changeProp("relative_address.relative")}
                options={props.masterOptions?.relative}
                search={true}
                selection={true}
                style={{width: "100%"}}
                value={props.patient?.relative_address?.relative}>
              </Dropdown>
            </FormField>
          </FormGroup>
          <FormGroup
            id="CardPatientInfoREGUX-FormGroup-95"
            inline={true}>
            <FormField
              id="CardPatientInfoREGUX-FormField-100"
              inline={true}>
              <label
                id="CardPatientInfoREGUX-label-113"
                style={{minWidth: "80px", maxWidth: "80px",fontWeight: "normal"}}>
                {props.languageUX === "en" ? "alias" : "นามแฝง"}
              </label>
            </FormField>
            <FormField
              id="CardPatientInfoREGUX-FormField-111"
              inline={true}>
              <Checkbox
                checked={props?.patient?.nickname_active || false}
                id="CardPatientInfoREGUX-Checkbox-112"
                onChange={props?.handleCheckNameActive}
                toggle={true}>
              </Checkbox>
            </FormField>
          </FormGroup>
          <FormGroup
            id="CardPatientInfoREGUX-FormGroup-142"
            inline={true}
            style={{display: !props?.patient?.nickname_active ? "none" : ""}}>
            <FormField
              id="CardPatientInfoREGUX-FormField-144"
              inline={true}
              width={6}>
              <label
                id="CardPatientInfoREGUX-label-148"
                style={{width: "129px",fontWeight: "normal"}}>
                {props.languageUX === "en" ? "Pseudonym" : "ชื่อนามแฝง"}
              </label>
              <Dropdown
                clearable={true}
                disabled={props?.isNicknameActive}
                fluid={true}
                id="CardPatientInfoREGUX-Dropdown-152"
                onChange={props.changeProp("nickname")}
                options={props?.masterOptions?.nickname}
                search={true}
                selection={true}
                style={{width: "100%"}}
                value={props?.patient?.nickname}>
              </Dropdown>
            </FormField>
            <FormField
              id="CardPatientInfoREGUX-FormField-145"
              inline={true}
              width={5}>
              <label
                id="CardPatientInfoREGUX-label-149"
                style={{width: "110px",fontWeight: "normal"}}>
                {props.languageUX === "en" ? "Pseudonym approval number" : "เลขที่อนุมัตินามแฝง"}
              </label>
              <Input
                disabled={props?.isNicknameActive}
                fluid={true}
                id="CardPatientInfoREGUX-Input-154"
                onChange={props.changeProp("nickname_permit_no")}
                style={{width: "100%"}}
                value={props?.patient?.nickname_permit_no || ""}>
              </Input>
            </FormField>
          </FormGroup>
          <FormGroup
            id="CardPatientInfoREGUX-FormGroup-143"
            inline={true}
            style={{display: !props?.patient?.nickname_active ? "none" : ""}}>
            <FormField
              id="CardPatientInfoREGUX-FormField-146"
              inline={true}
              width={6}>
              <label
                id="CardPatientInfoREGUX-label-150"
                style={{width: "129px",fontWeight: "normal"}}>
                {props.languageUX === "en" ? "reason" : "เหตุผล"}
              </label>
              <Dropdown
                clearable={true}
                disabled={props?.isNicknameActive}
                fluid={true}
                id="CardPatientInfoREGUX-Dropdown-153"
                onAddItem={props.onAddOptions}
                onChange={props.changeProp("nickname_reason")}
                options={props?.reasonOptions}
                search={true}
                selection={true}
                style={{width: "100%"}}
                value={props?.patient?.nickname_reason}>
              </Dropdown>
            </FormField>
            <FormField
              id="CardPatientInfoREGUX-FormField-147"
              inline={true}
              width={5}>
              <label
                id="CardPatientInfoREGUX-label-151"
                style={{width: "105px",fontWeight: "normal"}}>
                {props.languageUX === "en" ? "Pseudonym approver" : "ผู้อนุมัตินามแฝง"}
              </label>
              <Input
                disabled={props?.isNicknameActive}
                fluid={true}
                id="CardPatientInfoREGUX-Input-155"
                onChange={props.changeProp("nickname_warrantor")}
                style={{width: "100%"}}
                value={props?.patient?.nickname_warrantor || ""}>
              </Input>
            </FormField>
          </FormGroup>
          <FormGroup
            id="CardPatientInfoREGUX-FormGroup-114"
            inline={true}
            style={{marginBottom: "3rem"}}>
            <FormField
              id="CardPatientInfoREGUX-FormField-115"
              inline={true}
              style={{flex: 1}}>
            </FormField>
            <FormField
              id="CardPatientInfoREGUX-FormField-116"
              inline={true}
              style={{display: "none"}}>
              <div
                id="CardPatientInfoREGUX-div-156">
                {props.buttonSecret}
              </div>
            </FormField>
            <FormField
              id="CardPatientInfoREGUX-FormField-117"
              inline={true}>
              <div
                id="CardPatientInfoREGUX-div-137">
                {props.buttonSave}
              </div>
            </FormField>
          </FormGroup>
        </div>
      </div>
    )
}


export default CardPatientInfoREGUX

export const screenPropsDefault = {"first_name":"ชื่อทดสอบ","last_name":"สกุลทดสอบ","secretOptions":[{"key":"N","text":"ไม่ปกปิด","value":"N"},{"key":"S","text":"ปกปิดประวัติ","value":"S"}]}

/* Date Time : Thu Feb 19 2026 17:48:24 GMT+0700 (Indochina Time)
/* Original screen Data ************************************************************

{
  "elements": [
    {
      "id": 0,
      "name": "div",
      "parent": -1,
      "props": {
        "id": {
          "type": "value",
          "value": "CardPatientInfoREGUX-div-0"
        },
        "style": {
          "type": "code",
          "value": "{ width: \"100%\", height: \"100%\" ,padding: \"10px\"}"
        }
      },
      "seq": 0
    },
    {
      "from": null,
      "id": 1,
      "name": "div",
      "parent": 0,
      "props": {
        "children": {
          "type": "value",
          "value": ""
        },
        "id": {
          "type": "value",
          "value": "CardPatientInfoREGUX-div-1"
        },
        "style": {
          "type": "code",
          "value": "{ display: \"flex\", alignItems: \"center\" }"
        }
      },
      "seq": 1,
      "void": false
    },
    {
      "from": null,
      "id": 2,
      "name": "div",
      "parent": 1,
      "props": {
        "children": {
          "type": "value",
          "value": "ประวัติผู้ป่วย",
          "valueEN": "Patient history"
        },
        "id": {
          "type": "value",
          "value": "CardPatientInfoREGUX-div-2"
        },
        "style": {
          "type": "code",
          "value": "{marginBottom: \"0.5rem\", fontSize: \"1.2rem\", fontWeight: \"bold\"}"
        }
      },
      "seq": 2,
      "void": false
    },
    {
      "from": null,
      "id": 3,
      "name": "div",
      "parent": 0,
      "props": {
        "children": {
          "type": "value",
          "value": ""
        },
        "className": {
          "type": "value",
          "value": "ui form"
        },
        "id": {
          "type": "value",
          "value": "CardPatientInfoREGUX-div-3"
        }
      },
      "seq": 3,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 4,
      "name": "FormGroup",
      "parent": 3,
      "props": {
        "id": {
          "type": "value",
          "value": "CardPatientInfoREGUX-FormGroup-4"
        },
        "inline": {
          "type": "code",
          "value": "true"
        }
      },
      "seq": 4,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 5,
      "name": "FormField",
      "parent": 4,
      "props": {
        "id": {
          "type": "value",
          "value": "CardPatientInfoREGUX-FormField-5"
        },
        "inline": {
          "type": "code",
          "value": "true"
        },
        "style": {
          "type": "code",
          "value": ""
        },
        "width": {
          "type": "code",
          "value": "5"
        }
      },
      "seq": 5,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 6,
      "name": "FormField",
      "parent": 4,
      "props": {
        "id": {
          "type": "value",
          "value": "CardPatientInfoREGUX-FormField-6"
        },
        "inline": {
          "type": "code",
          "value": "true"
        },
        "width": {
          "type": "code",
          "value": "5"
        }
      },
      "seq": 6,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 8,
      "name": "FormField",
      "parent": 4,
      "props": {
        "className": {
          "type": "value",
          "value": "required"
        },
        "id": {
          "type": "value",
          "value": "CardPatientInfoREGUX-FormField-8"
        },
        "inline": {
          "type": "code",
          "value": "true"
        },
        "width": {
          "type": "code",
          "value": "6"
        }
      },
      "seq": 8,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 11,
      "name": "Input",
      "parent": 6,
      "props": {
        "disabled": {
          "type": "code",
          "value": "true"
        },
        "fluid": {
          "type": "code",
          "value": "true"
        },
        "id": {
          "type": "value",
          "value": "CardPatientInfoREGUX-Input-11"
        }
      },
      "seq": 11,
      "void": false
    },
    {
      "from": null,
      "id": 13,
      "name": "label",
      "parent": 5,
      "props": {
        "children": {
          "type": "value",
          "value": "HN ของระบบเดิม",
          "valueEN": "HN of the original system"
        },
        "id": {
          "type": "value",
          "value": "CardPatientInfoREGUX-label-13"
        },
        "style": {
          "type": "code",
          "value": "{textAlign: \"right\", width: \"100%\", fontWeight: \"normal\"}"
        }
      },
      "seq": 13,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 14,
      "name": "Dropdown",
      "parent": 8,
      "props": {
        "clearable": {
          "type": "code",
          "value": "true"
        },
        "fluid": {
          "type": "code",
          "value": "true"
        },
        "id": {
          "type": "value",
          "value": "cb-infoChanel"
        },
        "onChange": {
          "type": "code",
          "value": "props.changeProp(\"info_channel\")"
        },
        "options": {
          "type": "code",
          "value": "props.masterOptions?.infoChannel"
        },
        "selection": {
          "type": "code",
          "value": "true"
        },
        "style": {
          "type": "code",
          "value": "{width: \"100%\"}"
        },
        "value": {
          "type": "code",
          "value": "props.patient?.info_channel"
        }
      },
      "seq": 15,
      "void": false
    },
    {
      "from": null,
      "id": 15,
      "name": "label",
      "parent": 8,
      "props": {
        "children": {
          "type": "value",
          "value": "ช่องทางให้ข้อมูล",
          "valueEN": "Information channels"
        },
        "className": {
          "type": "value",
          "value": ""
        },
        "id": {
          "type": "value",
          "value": "CardPatientInfoREGUX-label-15"
        },
        "style": {
          "type": "code",
          "value": "{minWidth: \"max-content\", fontWeight: \"normal\", color: \"red\"}"
        }
      },
      "seq": 14,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 16,
      "name": "FormGroup",
      "parent": 3,
      "props": {
        "id": {
          "type": "value",
          "value": "CardPatientInfoREGUX-FormGroup-16"
        },
        "inline": {
          "type": "code",
          "value": "true"
        },
        "style": {
          "type": "code",
          "value": "{display: \"none\"}"
        }
      },
      "seq": 16,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 17,
      "name": "FormField",
      "parent": 16,
      "props": {
        "id": {
          "type": "value",
          "value": "CardPatientInfoREGUX-FormField-17"
        },
        "inline": {
          "type": "code",
          "value": "true"
        },
        "style": {
          "type": "code",
          "value": ""
        },
        "width": {
          "type": "code",
          "value": "5"
        }
      },
      "seq": 17,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 18,
      "name": "FormField",
      "parent": 16,
      "props": {
        "id": {
          "type": "value",
          "value": "CardPatientInfoREGUX-FormField-18"
        },
        "inline": {
          "type": "code",
          "value": "true"
        },
        "width": {
          "type": "code",
          "value": "5"
        }
      },
      "seq": 18,
      "void": false
    },
    {
      "from": null,
      "id": 19,
      "name": "label",
      "parent": 17,
      "props": {
        "children": {
          "type": "value",
          "value": "การปกปิดข้อมูลผู้ป่วย / Concealment of patient data",
          "valueEN": "Concealment of patient data"
        },
        "id": {
          "type": "value",
          "value": "CardPatientInfoREGUX-label-19"
        },
        "style": {
          "type": "code",
          "value": "{fontWeight: \"normal\"}"
        }
      },
      "seq": 19,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 20,
      "name": "Dropdown",
      "parent": 18,
      "props": {
        "clearable": {
          "type": "code",
          "value": "true"
        },
        "fluid": {
          "type": "code",
          "value": "true"
        },
        "id": {
          "type": "value",
          "value": "cb-conceal"
        },
        "onChange": {
          "type": "code",
          "value": "props.changeProp(\"is_secret\")"
        },
        "options": {
          "type": "code",
          "value": "props.secretOptions"
        },
        "search": {
          "type": "code",
          "value": "true"
        },
        "selection": {
          "type": "code",
          "value": "true"
        },
        "style": {
          "type": "code",
          "value": "{width: \"100%\"}"
        },
        "value": {
          "type": "code",
          "value": "props.patient?.is_secret"
        }
      },
      "seq": 20,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 21,
      "name": "FormGroup",
      "parent": 3,
      "props": {
        "id": {
          "type": "value",
          "value": "CardPatientInfoREGUX-FormGroup-21"
        },
        "inline": {
          "type": "code",
          "value": ""
        }
      },
      "seq": 21,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 22,
      "name": "FormField",
      "parent": 21,
      "props": {
        "className": {
          "type": "value",
          "value": "required"
        },
        "id": {
          "type": "value",
          "value": "CardPatientInfoREGUX-FormField-22"
        },
        "width": {
          "type": "code",
          "value": "5"
        }
      },
      "seq": 22,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 23,
      "name": "FormField",
      "parent": 21,
      "props": {
        "className": {
          "type": "code",
          "value": "props.citizenLable ? \"required\" : \"\""
        },
        "id": {
          "type": "value",
          "value": "CardPatientInfoREGUX-FormField-23"
        },
        "style": {
          "type": "code",
          "value": ""
        },
        "width": {
          "type": "code",
          "value": "6"
        }
      },
      "seq": 23,
      "void": false
    },
    {
      "from": null,
      "id": 24,
      "name": "label",
      "parent": 22,
      "props": {
        "children": {
          "type": "value",
          "value": "เอกสารระบุตัวตน / National Identification number",
          "valueEN": "National Identification Number"
        },
        "className": {
          "type": "value",
          "value": ""
        },
        "id": {
          "type": "value",
          "value": "CardPatientInfoREGUX-label-24"
        },
        "style": {
          "type": "code",
          "value": "{fontWeight: \"normal\", color: \"red\"}"
        }
      },
      "seq": 24,
      "void": false
    },
    {
      "from": null,
      "id": 25,
      "name": "label",
      "parent": 23,
      "props": {
        "children": {
          "type": "code",
          "value": "props.citizenLable || \"\\u00a0\""
        },
        "className": {
          "type": "code",
          "value": ""
        },
        "id": {
          "type": "value",
          "value": "CardPatientInfoREGUX-label-25"
        },
        "style": {
          "type": "code",
          "value": "{fontWeight: \"normal\", color: \"red\"}"
        }
      },
      "seq": 25,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 26,
      "name": "Dropdown",
      "parent": 22,
      "props": {
        "clearable": {
          "type": "code",
          "value": "true"
        },
        "fluid": {
          "type": "code",
          "value": "true"
        },
        "id": {
          "type": "value",
          "value": "cb-identify"
        },
        "onChange": {
          "type": "code",
          "value": "props.changeProp(\"citizen_type\")"
        },
        "options": {
          "type": "code",
          "value": "props.citizenTypeOptions"
        },
        "search": {
          "type": "code",
          "value": "true"
        },
        "selection": {
          "type": "code",
          "value": "true"
        },
        "style": {
          "type": "code",
          "value": "{width: \"100%\"}"
        },
        "value": {
          "type": "code",
          "value": "props.patient?.citizen_type"
        }
      },
      "seq": 26,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 28,
      "name": "FormField",
      "parent": 21,
      "props": {
        "id": {
          "type": "value",
          "value": "CardPatientInfoREGUX-FormField-28"
        }
      },
      "seq": 138,
      "void": false
    },
    {
      "from": null,
      "id": 30,
      "name": "label",
      "parent": 28,
      "props": {
        "children": {
          "type": "code",
          "value": "\"\\u00a0\""
        },
        "id": {
          "type": "value",
          "value": "CardPatientInfoREGUX-label-30"
        }
      },
      "seq": 29,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 31,
      "name": "FormGroup",
      "parent": 3,
      "props": {
        "id": {
          "type": "value",
          "value": "CardPatientInfoREGUX-FormGroup-31"
        }
      },
      "seq": 31,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 32,
      "name": "FormField",
      "parent": 31,
      "props": {
        "className": {
          "type": "code",
          "value": "(props.patient?.citizen_type === \"\" || props.patient?.citizen_type === \"T\") && \"required\""
        },
        "id": {
          "type": "value",
          "value": "CardPatientInfoREGUX-FormField-32"
        },
        "width": {
          "type": "code",
          "value": "3"
        }
      },
      "seq": 32,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 33,
      "name": "FormField",
      "parent": 31,
      "props": {
        "className": {
          "type": "code",
          "value": "(props.patient?.citizen_type === \"\" || props.patient?.citizen_type === \"T\") && \"required\""
        },
        "id": {
          "type": "value",
          "value": "CardPatientInfoREGUX-FormField-33"
        },
        "width": {
          "type": "code",
          "value": "4"
        }
      },
      "seq": 33,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 34,
      "name": "FormField",
      "parent": 31,
      "props": {
        "className": {
          "type": "code",
          "value": "(props.patient?.citizen_type === \"\" || props.patient?.citizen_type === \"T\") && \"required\""
        },
        "id": {
          "type": "value",
          "value": "CardPatientInfoREGUX-FormField-34"
        },
        "width": {
          "type": "code",
          "value": "4"
        }
      },
      "seq": 34,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 35,
      "name": "FormField",
      "parent": 31,
      "props": {
        "className": {
          "type": "value",
          "value": ""
        },
        "id": {
          "type": "value",
          "value": "CardPatientInfoREGUX-FormField-35"
        },
        "width": {
          "type": "code",
          "value": "4"
        }
      },
      "seq": 35,
      "void": false
    },
    {
      "from": null,
      "id": 36,
      "name": "label",
      "parent": 32,
      "props": {
        "children": {
          "type": "value",
          "value": "คำนำหน้า",
          "valueEN": "Prefix (TH)"
        },
        "className": {
          "type": "value",
          "value": ""
        },
        "id": {
          "type": "value",
          "value": "CardPatientInfoREGUX-label-36"
        },
        "style": {
          "type": "code",
          "value": "{fontWeight: \"normal\", ...(  (props.patient?.citizen_type === \"\" || props.patient?.citizen_type === \"T\") && {  color: \"red\" } )}"
        }
      },
      "seq": 36,
      "void": false
    },
    {
      "from": null,
      "id": 37,
      "name": "label",
      "parent": 33,
      "props": {
        "children": {
          "type": "value",
          "value": "ชื่อ",
          "valueEN": "First name (TH)"
        },
        "className": {
          "type": "value",
          "value": ""
        },
        "id": {
          "type": "value",
          "value": "CardPatientInfoREGUX-label-37"
        },
        "style": {
          "type": "code",
          "value": "{fontWeight: \"normal\", ...(  (props.patient?.citizen_type === \"\" || props.patient?.citizen_type === \"T\") && {  color: \"red\" } )}"
        }
      },
      "seq": 37,
      "void": false
    },
    {
      "from": null,
      "id": 38,
      "name": "label",
      "parent": 34,
      "props": {
        "children": {
          "type": "value",
          "value": "นามสกุล",
          "valueEN": "Last name (TH)"
        },
        "id": {
          "type": "value",
          "value": "CardPatientInfoREGUX-label-38"
        },
        "style": {
          "type": "code",
          "value": "{fontWeight: \"normal\", ...(  (props.patient?.citizen_type === \"\" || props.patient?.citizen_type === \"T\") && {  color: \"red\" } )}"
        }
      },
      "seq": 38,
      "void": false
    },
    {
      "from": null,
      "id": 39,
      "name": "label",
      "parent": 35,
      "props": {
        "children": {
          "type": "value",
          "value": "ชื่อกลาง",
          "valueEN": "Middle name (TH)"
        },
        "id": {
          "type": "value",
          "value": "CardPatientInfoREGUX-label-39"
        },
        "style": {
          "type": "code",
          "value": "{fontWeight: \"normal\"}"
        }
      },
      "seq": 39,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 40,
      "name": "Dropdown",
      "parent": 32,
      "props": {
        "clearable": {
          "type": "code",
          "value": "true"
        },
        "compact": {
          "type": "code",
          "value": "true"
        },
        "fluid": {
          "type": "code",
          "value": "true"
        },
        "id": {
          "type": "value",
          "value": "cb-prefix"
        },
        "onChange": {
          "type": "code",
          "value": "props.changeProp(\"pre_name_th\")"
        },
        "options": {
          "type": "code",
          "value": "props.masterOptions?.prenameTh"
        },
        "search": {
          "type": "code",
          "value": "true"
        },
        "selection": {
          "type": "code",
          "value": "true"
        },
        "style": {
          "type": "code",
          "value": "{width: \"100%\"}"
        },
        "value": {
          "type": "code",
          "value": "props.patient?.pre_name_th"
        }
      },
      "seq": 40,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 41,
      "name": "Input",
      "parent": 33,
      "props": {
        "fluid": {
          "type": "code",
          "value": "true"
        },
        "id": {
          "type": "value",
          "value": "txt-firstName"
        },
        "onChange": {
          "type": "code",
          "value": "props.changeProp(\"first_name_th\")"
        },
        "style": {
          "type": "code",
          "value": "{width: \"100%\"}"
        },
        "value": {
          "type": "code",
          "value": "props.patient?.first_name_th"
        }
      },
      "seq": 41,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 42,
      "name": "Input",
      "parent": 34,
      "props": {
        "fluid": {
          "type": "code",
          "value": "true"
        },
        "id": {
          "type": "value",
          "value": "txt-lastName"
        },
        "onChange": {
          "type": "code",
          "value": "props.changeProp(\"last_name_th\")"
        },
        "style": {
          "type": "code",
          "value": "{width: \"100%\"}"
        },
        "value": {
          "type": "code",
          "value": "props.patient?.last_name_th"
        }
      },
      "seq": 42,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 43,
      "name": "Input",
      "parent": 35,
      "props": {
        "fluid": {
          "type": "code",
          "value": "true"
        },
        "id": {
          "type": "value",
          "value": "CardPatientInfoREGUX-Input-43"
        },
        "onChange": {
          "type": "code",
          "value": "props.changeProp(\"middle_name_th\")"
        },
        "style": {
          "type": "code",
          "value": "{width: \"100%\"}"
        },
        "value": {
          "type": "code",
          "value": "props.patient?.middle_name_th"
        }
      },
      "seq": 43,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 44,
      "name": "FormGroup",
      "parent": 3,
      "props": {
        "id": {
          "type": "value",
          "value": "CardPatientInfoREGUX-FormGroup-44"
        }
      },
      "seq": 44,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 45,
      "name": "FormField",
      "parent": 44,
      "props": {
        "className": {
          "type": "code",
          "value": "(props.patient?.citizen_type !== \"\" && props.patient?.citizen_type !== \"T\") && \"required\""
        },
        "id": {
          "type": "value",
          "value": "CardPatientInfoREGUX-FormField-45"
        },
        "inline": {
          "type": "code",
          "value": "true"
        },
        "width": {
          "type": "code",
          "value": "3"
        }
      },
      "seq": 45,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 46,
      "name": "FormField",
      "parent": 44,
      "props": {
        "className": {
          "type": "code",
          "value": "(props.patient?.citizen_type !== \"\" && props.patient?.citizen_type !== \"T\") && \"required\""
        },
        "id": {
          "type": "value",
          "value": "CardPatientInfoREGUX-FormField-46"
        },
        "inline": {
          "type": "code",
          "value": "true"
        },
        "width": {
          "type": "code",
          "value": "4"
        }
      },
      "seq": 46,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 47,
      "name": "FormField",
      "parent": 44,
      "props": {
        "className": {
          "type": "code",
          "value": "(props.patient?.citizen_type !== \"\" && props.patient?.citizen_type !== \"T\") && \"required\""
        },
        "id": {
          "type": "value",
          "value": "CardPatientInfoREGUX-FormField-47"
        },
        "inline": {
          "type": "code",
          "value": "true"
        },
        "width": {
          "type": "code",
          "value": "4"
        }
      },
      "seq": 47,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 48,
      "name": "FormField",
      "parent": 44,
      "props": {
        "className": {
          "type": "code",
          "value": ""
        },
        "id": {
          "type": "value",
          "value": "CardPatientInfoREGUX-FormField-48"
        },
        "inline": {
          "type": "code",
          "value": "true"
        },
        "width": {
          "type": "code",
          "value": "4"
        }
      },
      "seq": 48,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 49,
      "name": "Dropdown",
      "parent": 45,
      "props": {
        "clearable": {
          "type": "code",
          "value": "true"
        },
        "compact": {
          "type": "code",
          "value": "true"
        },
        "fluid": {
          "type": "code",
          "value": "true"
        },
        "id": {
          "type": "value",
          "value": ""
        },
        "onChange": {
          "type": "code",
          "value": "props.changeProp(\"pre_name_en\")"
        },
        "options": {
          "type": "code",
          "value": "props.masterOptions?.prenameEn"
        },
        "search": {
          "type": "code",
          "value": "true"
        },
        "selection": {
          "type": "code",
          "value": "true"
        },
        "style": {
          "type": "code",
          "value": "{width: \"100%\"}"
        },
        "value": {
          "type": "code",
          "value": "props.patient?.pre_name_en"
        }
      },
      "seq": 177,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 50,
      "name": "Input",
      "parent": 46,
      "props": {
        "fluid": {
          "type": "code",
          "value": "true"
        },
        "id": {
          "type": "value",
          "value": "CardPatientInfoREGUX-Input-50"
        },
        "onChange": {
          "type": "code",
          "value": "props.changeProp(\"first_name_en\")"
        },
        "style": {
          "type": "code",
          "value": "{width: \"100%\"}"
        },
        "value": {
          "type": "code",
          "value": "props.patient?.first_name_en"
        }
      },
      "seq": 178,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 51,
      "name": "Input",
      "parent": 47,
      "props": {
        "fluid": {
          "type": "code",
          "value": "true"
        },
        "id": {
          "type": "value",
          "value": "CardPatientInfoREGUX-Input-51"
        },
        "onChange": {
          "type": "code",
          "value": "props.changeProp(\"last_name_en\")"
        },
        "style": {
          "type": "code",
          "value": "{width: \"100%\"}"
        },
        "value": {
          "type": "code",
          "value": "props.patient?.last_name_en"
        }
      },
      "seq": 179,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 52,
      "name": "Input",
      "parent": 48,
      "props": {
        "id": {
          "type": "value",
          "value": "CardPatientInfoREGUX-Input-52"
        },
        "onChange": {
          "type": "code",
          "value": "props.changeProp(\"middle_name_en\")"
        },
        "style": {
          "type": "code",
          "value": "{width: \"100%\"}"
        },
        "value": {
          "type": "code",
          "value": "props.patient?.middle_name_en"
        }
      },
      "seq": 180,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 53,
      "name": "FormGroup",
      "parent": 3,
      "props": {
        "id": {
          "type": "value",
          "value": "CardPatientInfoREGUX-FormGroup-53"
        },
        "inline": {
          "type": "code",
          "value": "true"
        }
      },
      "seq": 53,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 54,
      "name": "FormField",
      "parent": 53,
      "props": {
        "className": {
          "type": "value",
          "value": ""
        },
        "id": {
          "type": "value",
          "value": "CardPatientInfoREGUX-FormField-54"
        },
        "inline": {
          "type": "code",
          "value": "true"
        }
      },
      "seq": 54,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 55,
      "name": "FormField",
      "parent": 53,
      "props": {
        "id": {
          "type": "value",
          "value": "CardPatientInfoREGUX-FormField-55"
        },
        "inline": {
          "type": "code",
          "value": "true"
        },
        "width": {
          "type": "code",
          "value": "3"
        }
      },
      "seq": 55,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 56,
      "name": "FormField",
      "parent": 53,
      "props": {
        "className": {
          "type": "value",
          "value": "required"
        },
        "id": {
          "type": "value",
          "value": "CardPatientInfoREGUX-FormField-56"
        },
        "inline": {
          "type": "code",
          "value": "true"
        }
      },
      "seq": 56,
      "void": false
    },
    {
      "from": null,
      "id": 57,
      "name": "label",
      "parent": 54,
      "props": {
        "children": {
          "type": "value",
          "value": "เพศ / Gender*",
          "valueEN": "Gender/Gender*"
        },
        "className": {
          "type": "value",
          "value": ""
        },
        "id": {
          "type": "value",
          "value": "CardPatientInfoREGUX-label-57"
        },
        "style": {
          "type": "code",
          "value": "{minWidth: \"80px\", maxWidth: \"80px\",fontWeight: \"normal\", color: \"red\"}"
        }
      },
      "seq": 57,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 58,
      "name": "Dropdown",
      "parent": 55,
      "props": {
        "clearable": {
          "type": "code",
          "value": "true"
        },
        "compact": {
          "type": "code",
          "value": "true"
        },
        "fluid": {
          "type": "code",
          "value": "true"
        },
        "id": {
          "type": "value",
          "value": "cb-gender"
        },
        "onChange": {
          "type": "code",
          "value": "props.changeProp(\"gender\")"
        },
        "options": {
          "type": "code",
          "value": "props.masterOptions?.gender"
        },
        "search": {
          "type": "code",
          "value": "true"
        },
        "selection": {
          "type": "code",
          "value": "true"
        },
        "style": {
          "type": "code",
          "value": "{width: \"100%\"}"
        },
        "value": {
          "type": "code",
          "value": "props.patient?.gender"
        }
      },
      "seq": 58,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 59,
      "name": "FormField",
      "parent": 53,
      "props": {
        "id": {
          "type": "value",
          "value": "CardPatientInfoREGUX-FormField-59"
        },
        "inline": {
          "type": "code",
          "value": "true"
        },
        "width": {
          "type": "code",
          "value": "2"
        }
      },
      "seq": 59,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 60,
      "name": "Dropdown",
      "parent": 59,
      "props": {
        "clearable": {
          "type": "code",
          "value": "true"
        },
        "compact": {
          "type": "code",
          "value": "true"
        },
        "fluid": {
          "type": "code",
          "value": "true"
        },
        "id": {
          "type": "value",
          "value": "cb-blood"
        },
        "onChange": {
          "type": "code",
          "value": "props.changeProp(\"blood_type\")"
        },
        "options": {
          "type": "code",
          "value": "props.masterOptions?.bloodType"
        },
        "search": {
          "type": "code",
          "value": "true"
        },
        "selection": {
          "type": "code",
          "value": "true"
        },
        "style": {
          "type": "code",
          "value": "{width: \"100%\"}"
        },
        "value": {
          "type": "code",
          "value": "props.patient?.blood_type"
        }
      },
      "seq": 60,
      "void": false
    },
    {
      "from": null,
      "id": 61,
      "name": "label",
      "parent": 56,
      "props": {
        "children": {
          "type": "value",
          "value": "หมู่เลือด / Blood type",
          "valueEN": "Blood type"
        },
        "className": {
          "type": "value",
          "value": ""
        },
        "id": {
          "type": "value",
          "value": "CardPatientInfoREGUX-label-61"
        },
        "style": {
          "type": "code",
          "value": "{fontWeight: \"normal\", color: \"red\"}"
        }
      },
      "seq": 61,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 62,
      "name": "FormGroup",
      "parent": 3,
      "props": {
        "id": {
          "type": "value",
          "value": "CardPatientInfoREGUX-FormGroup-62"
        },
        "inline": {
          "type": "code",
          "value": "true"
        }
      },
      "seq": 62,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 63,
      "name": "FormGroup",
      "parent": 3,
      "props": {
        "id": {
          "type": "value",
          "value": "CardPatientInfoREGUX-FormGroup-63"
        },
        "inline": {
          "type": "code",
          "value": "true"
        }
      },
      "seq": 63,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 64,
      "name": "FormField",
      "parent": 63,
      "props": {
        "id": {
          "type": "value",
          "value": "CardPatientInfoREGUX-FormField-64"
        },
        "inline": {
          "type": "code",
          "value": "true"
        },
        "width": {
          "type": "code",
          "value": "5"
        }
      },
      "seq": 64,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 65,
      "name": "FormField",
      "parent": 63,
      "props": {
        "id": {
          "type": "value",
          "value": "CardPatientInfoREGUX-FormField-65"
        },
        "inline": {
          "type": "code",
          "value": "true"
        },
        "width": {
          "type": "code",
          "value": "6"
        }
      },
      "seq": 65,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 66,
      "name": "FormField",
      "parent": 63,
      "props": {
        "className": {
          "type": "value",
          "value": "required"
        },
        "id": {
          "type": "value",
          "value": "CardPatientInfoREGUX-FormField-66"
        },
        "inline": {
          "type": "code",
          "value": "true"
        },
        "width": {
          "type": "code",
          "value": "5"
        }
      },
      "seq": 66,
      "void": false
    },
    {
      "from": null,
      "id": 67,
      "name": "label",
      "parent": 64,
      "props": {
        "children": {
          "type": "value",
          "value": "ประเทศที่เกิด / Birth country",
          "valueEN": "Country of birth / Birth country"
        },
        "id": {
          "type": "value",
          "value": "CardPatientInfoREGUX-label-67"
        },
        "style": {
          "type": "code",
          "value": "{minWidth: \"80px\", maxWidth: \"80px\",fontWeight: \"normal\"}"
        }
      },
      "seq": 67,
      "void": false
    },
    {
      "from": null,
      "id": 68,
      "name": "label",
      "parent": 65,
      "props": {
        "children": {
          "type": "value",
          "value": "จังหวัดที่เกิด / Birth place",
          "valueEN": "Birth place"
        },
        "id": {
          "type": "value",
          "value": "CardPatientInfoREGUX-label-68"
        },
        "style": {
          "type": "code",
          "value": "{minWidth: \"85px\", maxWidth: \"85px\",fontWeight: \"normal\"}"
        }
      },
      "seq": 68,
      "void": false
    },
    {
      "from": null,
      "id": 69,
      "name": "label",
      "parent": 66,
      "props": {
        "children": {
          "type": "value",
          "value": "สัญชาติ / Nationality",
          "valueEN": "Nationality"
        },
        "className": {
          "type": "value",
          "value": ""
        },
        "id": {
          "type": "value",
          "value": "CardPatientInfoREGUX-label-69"
        },
        "style": {
          "type": "code",
          "value": "{minWidth: \"85px\", maxWidth: \"85px\",fontWeight: \"normal\", color: \"red\"}"
        }
      },
      "seq": 69,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 70,
      "name": "Dropdown",
      "parent": 64,
      "props": {
        "clearable": {
          "type": "code",
          "value": "true"
        },
        "fluid": {
          "type": "code",
          "value": "true"
        },
        "id": {
          "type": "value",
          "value": "CardPatientInfoREGUX-Dropdown-70"
        },
        "onChange": {
          "type": "code",
          "value": "props.changeProp(\"birth_country\")"
        },
        "options": {
          "type": "code",
          "value": "props.masterOptions?.country"
        },
        "search": {
          "type": "code",
          "value": "true"
        },
        "selection": {
          "type": "code",
          "value": "true"
        },
        "style": {
          "type": "code",
          "value": "{width: \"100%\"}"
        },
        "value": {
          "type": "code",
          "value": "props.patient?.birth_country"
        }
      },
      "seq": 70,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 71,
      "name": "Dropdown",
      "parent": 65,
      "props": {
        "clearable": {
          "type": "code",
          "value": "true"
        },
        "fluid": {
          "type": "code",
          "value": "true"
        },
        "id": {
          "type": "value",
          "value": "CardPatientInfoREGUX-Dropdown-71"
        },
        "onChange": {
          "type": "code",
          "value": "props.changeProp(\"birth_province\")"
        },
        "options": {
          "type": "code",
          "value": "props.masterOptions?.province"
        },
        "search": {
          "type": "code",
          "value": "true"
        },
        "selection": {
          "type": "code",
          "value": "true"
        },
        "style": {
          "type": "code",
          "value": "{width: \"100%\"}"
        },
        "value": {
          "type": "code",
          "value": "props.patient?.birth_province"
        }
      },
      "seq": 71,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 72,
      "name": "Dropdown",
      "parent": 66,
      "props": {
        "clearable": {
          "type": "code",
          "value": "true"
        },
        "compact": {
          "type": "code",
          "value": "true"
        },
        "fluid": {
          "type": "code",
          "value": "true"
        },
        "id": {
          "type": "value",
          "value": "txt-nationality"
        },
        "onChange": {
          "type": "code",
          "value": "props.changeProp(\"nationality\")"
        },
        "options": {
          "type": "code",
          "value": "props.masterOptions?.nationality"
        },
        "search": {
          "type": "code",
          "value": "true"
        },
        "selection": {
          "type": "code",
          "value": "true"
        },
        "style": {
          "type": "code",
          "value": "{width: \"100%\"}"
        },
        "value": {
          "type": "code",
          "value": "props.patient?.nationality"
        }
      },
      "seq": 72,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 73,
      "name": "FormGroup",
      "parent": 3,
      "props": {
        "id": {
          "type": "value",
          "value": "CardPatientInfoREGUX-FormGroup-73"
        },
        "inline": {
          "type": "code",
          "value": "true"
        }
      },
      "seq": 73,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 75,
      "name": "FormField",
      "parent": 73,
      "props": {
        "id": {
          "type": "value",
          "value": "CardPatientInfoREGUX-FormField-75"
        },
        "inline": {
          "type": "code",
          "value": "true"
        },
        "width": {
          "type": "code",
          "value": "8"
        }
      },
      "seq": 75,
      "void": false
    },
    {
      "from": null,
      "id": 78,
      "name": "label",
      "parent": 75,
      "props": {
        "children": {
          "type": "value",
          "value": "เชื้อชาติ / Ethnicity",
          "valueEN": "Ethnicity"
        },
        "id": {
          "type": "value",
          "value": "CardPatientInfoREGUX-label-78"
        },
        "style": {
          "type": "code",
          "value": "{minWidth: \"80px\", maxWidth: \"80px\",fontWeight: \"normal\"}"
        }
      },
      "seq": 78,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 79,
      "name": "FormField",
      "parent": 73,
      "props": {
        "id": {
          "type": "value",
          "value": "CardPatientInfoREGUX-FormField-79"
        },
        "inline": {
          "type": "code",
          "value": "true"
        },
        "width": {
          "type": "code",
          "value": "8"
        }
      },
      "seq": 79,
      "void": false
    },
    {
      "from": null,
      "id": 80,
      "name": "label",
      "parent": 79,
      "props": {
        "children": {
          "type": "value",
          "value": "ความเชื่อ / Belief",
          "valueEN": "Belief"
        },
        "id": {
          "type": "value",
          "value": "CardPatientInfoREGUX-label-80"
        },
        "style": {
          "type": "code",
          "value": "{width: \"125px\",fontWeight: \"normal\"}"
        }
      },
      "seq": 80,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 81,
      "name": "Dropdown",
      "parent": 79,
      "props": {
        "clearable": {
          "type": "code",
          "value": "true"
        },
        "fluid": {
          "type": "code",
          "value": "true"
        },
        "id": {
          "type": "value",
          "value": "CardPatientInfoREGUX-Dropdown-81"
        },
        "onChange": {
          "type": "code",
          "value": "props.changeProp(\"belief\")"
        },
        "options": {
          "type": "code",
          "value": "props.masterOptions?.belief"
        },
        "search": {
          "type": "code",
          "value": "true"
        },
        "selection": {
          "type": "code",
          "value": "true"
        },
        "style": {
          "type": "code",
          "value": "{width: \"100%\"}"
        },
        "value": {
          "type": "code",
          "value": "props.patient?.belief"
        }
      },
      "seq": 81,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 82,
      "name": "Dropdown",
      "parent": 75,
      "props": {
        "clearable": {
          "type": "code",
          "value": "true"
        },
        "fluid": {
          "type": "code",
          "value": "true"
        },
        "id": {
          "type": "value",
          "value": "CardPatientInfoREGUX-Dropdown-82"
        },
        "onChange": {
          "type": "code",
          "value": "props.changeProp(\"race\")"
        },
        "options": {
          "type": "code",
          "value": "props.masterOptions?.race"
        },
        "search": {
          "type": "code",
          "value": "true"
        },
        "selection": {
          "type": "code",
          "value": "true"
        },
        "style": {
          "type": "code",
          "value": "{width: \"100%\"}"
        },
        "value": {
          "type": "code",
          "value": "props.patient?.race"
        }
      },
      "seq": 82,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 83,
      "name": "FormGroup",
      "parent": 3,
      "props": {
        "id": {
          "type": "value",
          "value": "CardPatientInfoREGUX-FormGroup-83"
        },
        "inline": {
          "type": "code",
          "value": "true"
        }
      },
      "seq": 83,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 84,
      "name": "FormField",
      "parent": 83,
      "props": {
        "id": {
          "type": "value",
          "value": "CardPatientInfoREGUX-FormField-84"
        },
        "inline": {
          "type": "code",
          "value": "true"
        },
        "width": {
          "type": "code",
          "value": "5"
        }
      },
      "seq": 84,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 85,
      "name": "FormField",
      "parent": 83,
      "props": {
        "id": {
          "type": "value",
          "value": "CardPatientInfoREGUX-FormField-85"
        },
        "inline": {
          "type": "code",
          "value": "true"
        },
        "width": {
          "type": "code",
          "value": "6"
        }
      },
      "seq": 85,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 86,
      "name": "FormField",
      "parent": 83,
      "props": {
        "id": {
          "type": "value",
          "value": "CardPatientInfoREGUX-FormField-86"
        },
        "inline": {
          "type": "code",
          "value": "true"
        },
        "width": {
          "type": "code",
          "value": "5"
        }
      },
      "seq": 86,
      "void": false
    },
    {
      "from": null,
      "id": 87,
      "name": "label",
      "parent": 84,
      "props": {
        "children": {
          "type": "value",
          "value": "อาชีพ / Occupation",
          "valueEN": "Occupation"
        },
        "id": {
          "type": "value",
          "value": "CardPatientInfoREGUX-label-87"
        },
        "style": {
          "type": "code",
          "value": "{minWidth: \"80px\", maxWidth: \"80px\",fontWeight: \"normal\"}"
        }
      },
      "seq": 87,
      "void": false
    },
    {
      "from": null,
      "id": 88,
      "name": "label",
      "parent": 85,
      "props": {
        "children": {
          "type": "value",
          "value": "ตำแหน่งงาน / Position",
          "valueEN": "Job Position / Position"
        },
        "id": {
          "type": "value",
          "value": "CardPatientInfoREGUX-label-88"
        },
        "style": {
          "type": "code",
          "value": "{minWidth: \"85px\", maxWidth: \"85px\",fontWeight: \"normal\"}"
        }
      },
      "seq": 88,
      "void": false
    },
    {
      "from": null,
      "id": 89,
      "name": "label",
      "parent": 86,
      "props": {
        "children": {
          "type": "value",
          "value": "ระดับการศึกษา / Education",
          "valueEN": "Education level / Education"
        },
        "id": {
          "type": "value",
          "value": "CardPatientInfoREGUX-label-89"
        },
        "style": {
          "type": "code",
          "value": "{minWidth: \"85px\", maxWidth: \"85px\",fontWeight: \"normal\"}"
        }
      },
      "seq": 89,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 90,
      "name": "Dropdown",
      "parent": 84,
      "props": {
        "clearable": {
          "type": "code",
          "value": "true"
        },
        "fluid": {
          "type": "code",
          "value": "true"
        },
        "id": {
          "type": "value",
          "value": "CardPatientInfoREGUX-Dropdown-90"
        },
        "onChange": {
          "type": "code",
          "value": "props.changeProp(\"career\")"
        },
        "options": {
          "type": "code",
          "value": "props.masterOptions?.career"
        },
        "search": {
          "type": "code",
          "value": "true"
        },
        "selection": {
          "type": "code",
          "value": "true"
        },
        "style": {
          "type": "code",
          "value": "{width: \"100%\"}"
        },
        "value": {
          "type": "code",
          "value": "props.patient?.career"
        }
      },
      "seq": 90,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 91,
      "name": "Dropdown",
      "parent": 85,
      "props": {
        "clearable": {
          "type": "code",
          "value": "true"
        },
        "fluid": {
          "type": "code",
          "value": "true"
        },
        "id": {
          "type": "value",
          "value": "CardPatientInfoREGUX-Dropdown-91"
        },
        "onChange": {
          "type": "code",
          "value": "props.changeProp(\"position\")"
        },
        "options": {
          "type": "code",
          "value": "props.masterOptions?.position"
        },
        "search": {
          "type": "code",
          "value": "true"
        },
        "selection": {
          "type": "code",
          "value": "true"
        },
        "style": {
          "type": "code",
          "value": "{width: \"100%\"}"
        },
        "value": {
          "type": "code",
          "value": "props.patient?.position"
        }
      },
      "seq": 91,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 92,
      "name": "Dropdown",
      "parent": 86,
      "props": {
        "clearable": {
          "type": "code",
          "value": "true"
        },
        "fluid": {
          "type": "code",
          "value": "true"
        },
        "id": {
          "type": "value",
          "value": "CardPatientInfoREGUX-Dropdown-92"
        },
        "onChange": {
          "type": "code",
          "value": "props.changeProp(\"education\")"
        },
        "options": {
          "type": "code",
          "value": "props.masterOptions?.education"
        },
        "search": {
          "type": "code",
          "value": "true"
        },
        "selection": {
          "type": "code",
          "value": "true"
        },
        "style": {
          "type": "code",
          "value": "{width: \"100%\"}"
        },
        "value": {
          "type": "code",
          "value": "props.patient?.education"
        }
      },
      "seq": 92,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 93,
      "name": "FormGroup",
      "parent": 3,
      "props": {
        "id": {
          "type": "value",
          "value": "CardPatientInfoREGUX-FormGroup-93"
        },
        "inline": {
          "type": "code",
          "value": "true"
        }
      },
      "seq": 93,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 94,
      "name": "FormGroup",
      "parent": 3,
      "props": {
        "id": {
          "type": "value",
          "value": "CardPatientInfoREGUX-FormGroup-94"
        },
        "inline": {
          "type": "code",
          "value": "true"
        }
      },
      "seq": 94,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 95,
      "name": "FormGroup",
      "parent": 3,
      "props": {
        "id": {
          "type": "value",
          "value": "CardPatientInfoREGUX-FormGroup-95"
        },
        "inline": {
          "type": "code",
          "value": "true"
        }
      },
      "seq": 114,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 96,
      "name": "FormField",
      "parent": 93,
      "props": {
        "id": {
          "type": "value",
          "value": "CardPatientInfoREGUX-FormField-96"
        },
        "inline": {
          "type": "code",
          "value": "true"
        },
        "width": {
          "type": "code",
          "value": "8"
        }
      },
      "seq": 96,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 97,
      "name": "FormField",
      "parent": 93,
      "props": {
        "id": {
          "type": "value",
          "value": "CardPatientInfoREGUX-FormField-97"
        },
        "inline": {
          "type": "code",
          "value": "true"
        },
        "width": {
          "type": "code",
          "value": "8"
        }
      },
      "seq": 97,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 98,
      "name": "FormField",
      "parent": 94,
      "props": {
        "className": {
          "type": "code",
          "value": "props.isRequired && \"required\""
        },
        "id": {
          "type": "value",
          "value": "CardPatientInfoREGUX-FormField-98"
        },
        "inline": {
          "type": "code",
          "value": "true"
        },
        "width": {
          "type": "code",
          "value": "8"
        }
      },
      "seq": 98,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 99,
      "name": "FormField",
      "parent": 94,
      "props": {
        "className": {
          "type": "code",
          "value": "props.isRequired && \"required\""
        },
        "id": {
          "type": "value",
          "value": "CardPatientInfoREGUX-FormField-99"
        },
        "inline": {
          "type": "code",
          "value": "true"
        },
        "width": {
          "type": "code",
          "value": "8"
        }
      },
      "seq": 99,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 100,
      "name": "FormField",
      "parent": 95,
      "props": {
        "id": {
          "type": "value",
          "value": "CardPatientInfoREGUX-FormField-100"
        },
        "inline": {
          "type": "code",
          "value": "true"
        }
      },
      "seq": 100,
      "void": false
    },
    {
      "from": null,
      "id": 102,
      "name": "label",
      "parent": 96,
      "props": {
        "children": {
          "type": "value",
          "value": "สถานภาพสมรส / Marital status",
          "valueEN": "Marital status"
        },
        "id": {
          "type": "value",
          "value": "CardPatientInfoREGUX-label-102"
        },
        "style": {
          "type": "code",
          "value": "{minWidth: \"80px\", maxWidth: \"80px\",fontWeight: \"normal\"}"
        }
      },
      "seq": 102,
      "void": false
    },
    {
      "from": null,
      "id": 103,
      "name": "label",
      "parent": 98,
      "props": {
        "children": {
          "type": "value",
          "value": "ชื่อบิดา / Father's Name",
          "valueEN": "Father's Name"
        },
        "className": {
          "type": "value",
          "value": ""
        },
        "id": {
          "type": "value",
          "value": "CardPatientInfoREGUX-label-103"
        },
        "style": {
          "type": "code",
          "value": "{minWidth: \"80px\", maxWidth: \"80px\",fontWeight: \"normal\", ...(props.isRequired && {color: \"red\"})}"
        }
      },
      "seq": 103,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 105,
      "name": "Dropdown",
      "parent": 96,
      "props": {
        "clearable": {
          "type": "code",
          "value": "true"
        },
        "fluid": {
          "type": "code",
          "value": "true"
        },
        "id": {
          "type": "value",
          "value": "CardPatientInfoREGUX-Dropdown-105"
        },
        "onChange": {
          "type": "code",
          "value": "props.changeProp(\"marriage\")"
        },
        "options": {
          "type": "code",
          "value": "props.marriageOptions"
        },
        "search": {
          "type": "code",
          "value": "true"
        },
        "selection": {
          "type": "code",
          "value": "true"
        },
        "style": {
          "type": "code",
          "value": "{width: \"100%\"}"
        },
        "value": {
          "type": "code",
          "value": "props.patient?.marriage"
        }
      },
      "seq": 105,
      "void": false
    },
    {
      "from": null,
      "id": 106,
      "name": "label",
      "parent": 97,
      "props": {
        "children": {
          "type": "value",
          "value": "ชื่อคู่สมรส / Spouse's Name",
          "valueEN": "Spouse's Name"
        },
        "id": {
          "type": "value",
          "value": "CardPatientInfoREGUX-label-106"
        },
        "style": {
          "type": "code",
          "value": "{minWidth: \"100px\", maxWidth: \"100px\",fontWeight: \"normal\"}"
        }
      },
      "seq": 106,
      "void": false
    },
    {
      "from": null,
      "id": 107,
      "name": "label",
      "parent": 99,
      "props": {
        "children": {
          "type": "value",
          "value": "ชื่อมารดา / Mother's Name",
          "valueEN": "Mother's Name"
        },
        "className": {
          "type": "value",
          "value": ""
        },
        "id": {
          "type": "value",
          "value": "CardPatientInfoREGUX-label-107"
        },
        "style": {
          "type": "code",
          "value": "{minWidth: \"80px\", maxWidth: \"80px\",fontWeight: \"normal\", ...(props.isRequired && {color: \"red\"})}"
        }
      },
      "seq": 107,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 108,
      "name": "Input",
      "parent": 99,
      "props": {
        "fluid": {
          "type": "code",
          "value": "true"
        },
        "id": {
          "type": "value",
          "value": "txt-motherName"
        },
        "onChange": {
          "type": "code",
          "value": "props.changeProp(\"mother\")"
        },
        "style": {
          "type": "code",
          "value": "{width: \"100%\"}"
        },
        "value": {
          "type": "code",
          "value": "props.patient?.mother"
        }
      },
      "seq": 108,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 109,
      "name": "Input",
      "parent": 98,
      "props": {
        "fluid": {
          "type": "code",
          "value": "true"
        },
        "id": {
          "type": "value",
          "value": "txt-fatherName"
        },
        "onChange": {
          "type": "code",
          "value": "props.changeProp(\"father\")"
        },
        "style": {
          "type": "code",
          "value": "{width: \"100%\"}"
        },
        "value": {
          "type": "code",
          "value": "props.patient?.father"
        }
      },
      "seq": 109,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 110,
      "name": "Input",
      "parent": 97,
      "props": {
        "fluid": {
          "type": "code",
          "value": "true"
        },
        "id": {
          "type": "value",
          "value": "CardPatientInfoREGUX-Input-110"
        },
        "onChange": {
          "type": "code",
          "value": "props.changeProp(\"couple\")"
        },
        "style": {
          "type": "code",
          "value": "{width: \"100%\"}"
        },
        "value": {
          "type": "code",
          "value": "props.patient?.couple"
        }
      },
      "seq": 110,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 111,
      "name": "FormField",
      "parent": 95,
      "props": {
        "id": {
          "type": "value",
          "value": "CardPatientInfoREGUX-FormField-111"
        },
        "inline": {
          "type": "code",
          "value": "true"
        }
      },
      "seq": 111,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 112,
      "name": "Checkbox",
      "parent": 111,
      "props": {
        "checked": {
          "type": "code",
          "value": "props?.patient?.nickname_active || false"
        },
        "id": {
          "type": "value",
          "value": "CardPatientInfoREGUX-Checkbox-112"
        },
        "onChange": {
          "type": "code",
          "value": "props?.handleCheckNameActive"
        },
        "toggle": {
          "type": "code",
          "value": "true"
        }
      },
      "seq": 112,
      "void": false
    },
    {
      "from": null,
      "id": 113,
      "name": "label",
      "parent": 100,
      "props": {
        "children": {
          "type": "value",
          "value": "นามแฝง",
          "valueEN": "alias"
        },
        "id": {
          "type": "value",
          "value": "CardPatientInfoREGUX-label-113"
        },
        "style": {
          "type": "code",
          "value": "{minWidth: \"80px\", maxWidth: \"80px\",fontWeight: \"normal\"}"
        }
      },
      "seq": 113,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 114,
      "name": "FormGroup",
      "parent": 3,
      "props": {
        "id": {
          "type": "value",
          "value": "CardPatientInfoREGUX-FormGroup-114"
        },
        "inline": {
          "type": "code",
          "value": "true"
        },
        "style": {
          "type": "code",
          "value": "{marginBottom: \"3rem\"}"
        }
      },
      "seq": 158,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 115,
      "name": "FormField",
      "parent": 114,
      "props": {
        "id": {
          "type": "value",
          "value": "CardPatientInfoREGUX-FormField-115"
        },
        "inline": {
          "type": "code",
          "value": "true"
        },
        "style": {
          "type": "code",
          "value": "{flex: 1}"
        }
      },
      "seq": 115,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 116,
      "name": "FormField",
      "parent": 114,
      "props": {
        "id": {
          "type": "value",
          "value": "CardPatientInfoREGUX-FormField-116"
        },
        "inline": {
          "type": "code",
          "value": "true"
        },
        "style": {
          "type": "code",
          "value": "{display: \"none\"}"
        }
      },
      "seq": 116,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 117,
      "name": "FormField",
      "parent": 114,
      "props": {
        "id": {
          "type": "value",
          "value": "CardPatientInfoREGUX-FormField-117"
        },
        "inline": {
          "type": "code",
          "value": "true"
        }
      },
      "seq": 117,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 120,
      "name": "FormField",
      "parent": 62,
      "props": {
        "className": {
          "type": "value",
          "value": "required"
        },
        "id": {
          "type": "value",
          "value": "CardPatientInfoREGUX-FormField-120"
        },
        "inline": {
          "type": "code",
          "value": "true"
        },
        "width": {
          "type": "code",
          "value": "5"
        }
      },
      "seq": 120,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 121,
      "name": "FormField",
      "parent": 62,
      "props": {
        "id": {
          "type": "value",
          "value": "CardPatientInfoREGUX-FormField-121"
        },
        "inline": {
          "type": "code",
          "value": "true"
        },
        "width": {
          "type": "code",
          "value": "3"
        }
      },
      "seq": 121,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 122,
      "name": "FormField",
      "parent": 62,
      "props": {
        "id": {
          "type": "value",
          "value": "CardPatientInfoREGUX-FormField-122"
        },
        "inline": {
          "type": "code",
          "value": "true"
        },
        "width": {
          "type": "code",
          "value": "4"
        }
      },
      "seq": 122,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 123,
      "name": "FormField",
      "parent": 62,
      "props": {
        "id": {
          "type": "value",
          "value": "CardPatientInfoREGUX-FormField-123"
        },
        "inline": {
          "type": "code",
          "value": "true"
        },
        "width": {
          "type": "code",
          "value": "4"
        }
      },
      "seq": 123,
      "void": false
    },
    {
      "from": null,
      "id": 124,
      "name": "label",
      "parent": 120,
      "props": {
        "children": {
          "type": "value",
          "value": "วันเดือนปีเกิด date of birth",
          "valueEN": "Date of birth"
        },
        "id": {
          "type": "value",
          "value": "CardPatientInfoREGUX-label-124"
        },
        "style": {
          "type": "code",
          "value": "{minWidth: \"80px\", maxWidth: \"80px\",fontWeight: \"normal\", color: \"red\"}"
        }
      },
      "seq": 124,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 129,
      "name": "Checkbox",
      "parent": 121,
      "props": {
        "checked": {
          "type": "code",
          "value": "props.patient?.use_birthdate_special"
        },
        "id": {
          "type": "value",
          "value": "CardPatientInfoREGUX-Checkbox-129"
        },
        "name": {
          "type": "value",
          "value": "use_birthdate_special"
        },
        "onChange": {
          "type": "code",
          "value": "props.changeBirthdateSpecial"
        }
      },
      "seq": 129,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 130,
      "name": "Dropdown",
      "parent": 121,
      "props": {
        "disabled": {
          "type": "code",
          "value": "!props.patient?.use_birthdate_special"
        },
        "fluid": {
          "type": "code",
          "value": "true"
        },
        "id": {
          "type": "value",
          "value": "CardPatientInfoREGUX-Dropdown-130"
        },
        "onChange": {
          "type": "code",
          "value": "props.changeProp(\"birthdate\")"
        },
        "options": {
          "type": "code",
          "value": "[ {key: 1, value: \"\", text: \"ไม่ระบุ\"}, { key: 2, value: \"28/02/2482\", text: \"29/02/2482\" }, { key: 3, value: \"28/02/2478\", text: \"29/02/2478\" }, { key: 4, value: \"28/02/2474\", text: \"29/02/2474\" }, { key: 5, value: \"28/02/2470\", text: \"29/02/2470\" }, { key: 6, value: \"28/02/2466\", text: \"29/02/2466\" }, { key: 7, value: \"28/02/2462\", text: \"29/02/2462\" }, { key: 8, value: \"28/02/2458\", text: \"29/02/2458\" }, { key: 9, value: \"28/02/2454\", text: \"29/02/2454\" }, { key: 10, value: \"28/02/2450\", text: \"29/02/2450\" }, { key: 11, value: \"28/02/2446\", text: \"29/02/2446\" }, { key: 12, value: \"28/02/2442\", text: \"29/02/2442\" } ]"
        },
        "search": {
          "type": "code",
          "value": "true"
        },
        "selection": {
          "type": "code",
          "value": "true"
        },
        "style": {
          "type": "code",
          "value": "{width: \"100%\"}"
        },
        "value": {
          "type": "code",
          "value": "props.patient?.use_birthdate_special ? props.patient?.birthdate : \"\""
        }
      },
      "seq": 130,
      "void": false
    },
    {
      "from": null,
      "id": 131,
      "name": "label",
      "parent": 122,
      "props": {
        "children": {
          "type": "value",
          "value": "อายุ / Age",
          "valueEN": "Age / Age"
        },
        "id": {
          "type": "value",
          "value": "CardPatientInfoREGUX-label-131"
        },
        "style": {
          "type": "code",
          "value": "{minWidth: \"max-content\",fontWeight: \"normal\"}"
        }
      },
      "seq": 131,
      "void": false
    },
    {
      "from": null,
      "id": 132,
      "name": "label",
      "parent": 123,
      "props": {
        "children": {
          "type": "value",
          "value": "ศาสนา / Religion",
          "valueEN": "Religion"
        },
        "id": {
          "type": "value",
          "value": "CardPatientInfoREGUX-label-132"
        },
        "style": {
          "type": "code",
          "value": "{minWidth: \"50px\",maxWidth: \"50px\",fontWeight: \"normal\"}"
        }
      },
      "seq": 132,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 133,
      "name": "Dropdown",
      "parent": 123,
      "props": {
        "className": {
          "type": "value",
          "value": "cb-nationality"
        },
        "clearable": {
          "type": "code",
          "value": "true"
        },
        "fluid": {
          "type": "code",
          "value": "true"
        },
        "id": {
          "type": "value",
          "value": "CardPatientInfoREGUX-Dropdown-133"
        },
        "onChange": {
          "type": "code",
          "value": "props.changeProp(\"religion_code\")"
        },
        "options": {
          "type": "code",
          "value": "props.masterOptions?.religion"
        },
        "search": {
          "type": "code",
          "value": "true"
        },
        "selection": {
          "type": "code",
          "value": "true"
        },
        "style": {
          "type": "code",
          "value": "{width: \"100%\"}"
        },
        "value": {
          "type": "code",
          "value": "props.patient?.religion_code"
        }
      },
      "seq": 133,
      "void": false
    },
    {
      "from": null,
      "id": 134,
      "name": "div",
      "parent": 120,
      "props": {
        "children": {
          "type": "code",
          "value": "props.dateTextBox"
        },
        "id": {
          "type": "value",
          "value": "CardPatientInfoREGUX-div-134"
        },
        "style": {
          "type": "code",
          "value": "{width: \"100%\"}"
        }
      },
      "seq": 134,
      "void": false
    },
    {
      "from": null,
      "id": 135,
      "name": "div",
      "parent": 122,
      "props": {
        "children": {
          "type": "code",
          "value": "props.age"
        },
        "id": {
          "type": "value",
          "value": "CardPatientInfoREGUX-div-135"
        },
        "style": {
          "type": "code",
          "value": "{width: \"100%\"}"
        }
      },
      "seq": 135,
      "void": false
    },
    {
      "from": null,
      "id": 136,
      "name": "div",
      "parent": 23,
      "props": {
        "children": {
          "type": "code",
          "value": "props.citizenInput"
        },
        "id": {
          "type": "value",
          "value": "CardPatientInfoREGUX-div-136"
        },
        "style": {
          "type": "code",
          "value": "{width: \"100%\"}"
        }
      },
      "seq": 136,
      "void": false
    },
    {
      "from": null,
      "id": 137,
      "name": "div",
      "parent": 117,
      "props": {
        "children": {
          "type": "code",
          "value": "props.buttonSave"
        },
        "id": {
          "type": "value",
          "value": "CardPatientInfoREGUX-div-137"
        }
      },
      "seq": 137,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 138,
      "name": "FormField",
      "parent": 21,
      "props": {
        "id": {
          "type": "value",
          "value": "CardPatientInfoREGUX-FormField-138"
        },
        "style": {
          "type": "code",
          "value": ""
        },
        "width": {
          "type": "code",
          "value": "4"
        }
      },
      "seq": 28,
      "void": false
    },
    {
      "from": null,
      "id": 139,
      "name": "label",
      "parent": 138,
      "props": {
        "children": {
          "type": "code",
          "value": "props.reimburseLabel|| \"\\u00a0\""
        },
        "id": {
          "type": "value",
          "value": "CardPatientInfoREGUX-label-139"
        },
        "style": {
          "type": "code",
          "value": "{fontWeight: \"normal\"}"
        }
      },
      "seq": 139,
      "void": false
    },
    {
      "from": null,
      "id": 140,
      "name": "div",
      "parent": 138,
      "props": {
        "children": {
          "type": "code",
          "value": "props.reimburseInput"
        },
        "id": {
          "type": "value",
          "value": "CardPatientInfoREGUX-div-140"
        }
      },
      "seq": 140,
      "void": false
    },
    {
      "from": null,
      "id": 141,
      "name": "div",
      "parent": 28,
      "props": {
        "children": {
          "type": "code",
          "value": "props.nonResidentChk"
        },
        "id": {
          "type": "value",
          "value": "CardPatientInfoREGUX-div-141"
        }
      },
      "seq": 141,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 142,
      "name": "FormGroup",
      "parent": 3,
      "props": {
        "id": {
          "type": "value",
          "value": "CardPatientInfoREGUX-FormGroup-142"
        },
        "inline": {
          "type": "code",
          "value": "true"
        },
        "style": {
          "type": "code",
          "value": "{display: !props?.patient?.nickname_active ? \"none\" : \"\"}"
        }
      },
      "seq": 142,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 143,
      "name": "FormGroup",
      "parent": 3,
      "props": {
        "id": {
          "type": "value",
          "value": "CardPatientInfoREGUX-FormGroup-143"
        },
        "inline": {
          "type": "code",
          "value": "true"
        },
        "style": {
          "type": "code",
          "value": "{display: !props?.patient?.nickname_active ? \"none\" : \"\"}"
        }
      },
      "seq": 143,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 144,
      "name": "FormField",
      "parent": 142,
      "props": {
        "id": {
          "type": "value",
          "value": "CardPatientInfoREGUX-FormField-144"
        },
        "inline": {
          "type": "code",
          "value": "true"
        },
        "width": {
          "type": "code",
          "value": "6"
        }
      },
      "seq": 144,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 145,
      "name": "FormField",
      "parent": 142,
      "props": {
        "id": {
          "type": "value",
          "value": "CardPatientInfoREGUX-FormField-145"
        },
        "inline": {
          "type": "code",
          "value": "true"
        },
        "width": {
          "type": "code",
          "value": "5"
        }
      },
      "seq": 145,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 146,
      "name": "FormField",
      "parent": 143,
      "props": {
        "id": {
          "type": "value",
          "value": "CardPatientInfoREGUX-FormField-146"
        },
        "inline": {
          "type": "code",
          "value": "true"
        },
        "width": {
          "type": "code",
          "value": "6"
        }
      },
      "seq": 146,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 147,
      "name": "FormField",
      "parent": 143,
      "props": {
        "id": {
          "type": "value",
          "value": "CardPatientInfoREGUX-FormField-147"
        },
        "inline": {
          "type": "code",
          "value": "true"
        },
        "style": {
          "type": "code",
          "value": ""
        },
        "width": {
          "type": "code",
          "value": "5"
        }
      },
      "seq": 147,
      "void": false
    },
    {
      "from": null,
      "id": 148,
      "name": "label",
      "parent": 144,
      "props": {
        "children": {
          "type": "value",
          "value": "ชื่อนามแฝง",
          "valueEN": "Pseudonym"
        },
        "id": {
          "type": "value",
          "value": "CardPatientInfoREGUX-label-148"
        },
        "style": {
          "type": "code",
          "value": "{width: \"129px\",fontWeight: \"normal\"}"
        }
      },
      "seq": 148,
      "void": false
    },
    {
      "from": null,
      "id": 149,
      "name": "label",
      "parent": 145,
      "props": {
        "children": {
          "type": "value",
          "value": "เลขที่อนุมัตินามแฝง",
          "valueEN": "Pseudonym approval number"
        },
        "id": {
          "type": "value",
          "value": "CardPatientInfoREGUX-label-149"
        },
        "style": {
          "type": "code",
          "value": "{width: \"110px\",fontWeight: \"normal\"}"
        }
      },
      "seq": 149,
      "void": false
    },
    {
      "from": null,
      "id": 150,
      "name": "label",
      "parent": 146,
      "props": {
        "children": {
          "type": "value",
          "value": "เหตุผล",
          "valueEN": "reason"
        },
        "id": {
          "type": "value",
          "value": "CardPatientInfoREGUX-label-150"
        },
        "style": {
          "type": "code",
          "value": "{width: \"129px\",fontWeight: \"normal\"}"
        }
      },
      "seq": 150,
      "void": false
    },
    {
      "from": null,
      "id": 151,
      "name": "label",
      "parent": 147,
      "props": {
        "children": {
          "type": "value",
          "value": "ผู้อนุมัตินามแฝง",
          "valueEN": "Pseudonym approver"
        },
        "id": {
          "type": "value",
          "value": "CardPatientInfoREGUX-label-151"
        },
        "style": {
          "type": "code",
          "value": "{width: \"105px\",fontWeight: \"normal\"}"
        }
      },
      "seq": 151,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 152,
      "name": "Dropdown",
      "parent": 144,
      "props": {
        "clearable": {
          "type": "code",
          "value": "true"
        },
        "disabled": {
          "type": "code",
          "value": "props?.isNicknameActive"
        },
        "fluid": {
          "type": "code",
          "value": "true"
        },
        "id": {
          "type": "value",
          "value": "CardPatientInfoREGUX-Dropdown-152"
        },
        "onChange": {
          "type": "code",
          "value": "props.changeProp(\"nickname\")"
        },
        "options": {
          "type": "code",
          "value": "props?.masterOptions?.nickname"
        },
        "search": {
          "type": "code",
          "value": "true"
        },
        "selection": {
          "type": "code",
          "value": "true"
        },
        "style": {
          "type": "code",
          "value": "{width: \"100%\"}"
        },
        "value": {
          "type": "code",
          "value": "props?.patient?.nickname"
        }
      },
      "seq": 152,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 153,
      "name": "Dropdown",
      "parent": 146,
      "props": {
        "clearable": {
          "type": "code",
          "value": "true"
        },
        "disabled": {
          "type": "code",
          "value": "props?.isNicknameActive"
        },
        "fluid": {
          "type": "code",
          "value": "true"
        },
        "id": {
          "type": "value",
          "value": "CardPatientInfoREGUX-Dropdown-153"
        },
        "onAddItem": {
          "type": "code",
          "value": "props.onAddOptions"
        },
        "onChange": {
          "type": "code",
          "value": "props.changeProp(\"nickname_reason\")"
        },
        "options": {
          "type": "code",
          "value": "props?.reasonOptions"
        },
        "search": {
          "type": "code",
          "value": "true"
        },
        "selection": {
          "type": "code",
          "value": "true"
        },
        "style": {
          "type": "code",
          "value": "{width: \"100%\"}"
        },
        "value": {
          "type": "code",
          "value": "props?.patient?.nickname_reason"
        }
      },
      "seq": 153,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 154,
      "name": "Input",
      "parent": 145,
      "props": {
        "disabled": {
          "type": "code",
          "value": "props?.isNicknameActive"
        },
        "fluid": {
          "type": "code",
          "value": "true"
        },
        "id": {
          "type": "value",
          "value": "CardPatientInfoREGUX-Input-154"
        },
        "onChange": {
          "type": "code",
          "value": "props.changeProp(\"nickname_permit_no\")"
        },
        "style": {
          "type": "code",
          "value": "{width: \"100%\"}"
        },
        "value": {
          "type": "code",
          "value": "props?.patient?.nickname_permit_no || \"\""
        }
      },
      "seq": 154,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 155,
      "name": "Input",
      "parent": 147,
      "props": {
        "disabled": {
          "type": "code",
          "value": "props?.isNicknameActive"
        },
        "fluid": {
          "type": "code",
          "value": "true"
        },
        "id": {
          "type": "value",
          "value": "CardPatientInfoREGUX-Input-155"
        },
        "onChange": {
          "type": "code",
          "value": "props.changeProp(\"nickname_warrantor\")"
        },
        "style": {
          "type": "code",
          "value": "{width: \"100%\"}"
        },
        "value": {
          "type": "code",
          "value": "props?.patient?.nickname_warrantor || \"\""
        }
      },
      "seq": 155,
      "void": false
    },
    {
      "from": null,
      "id": 156,
      "name": "div",
      "parent": 116,
      "props": {
        "children": {
          "type": "code",
          "value": "props.buttonSecret"
        },
        "id": {
          "type": "value",
          "value": "CardPatientInfoREGUX-div-156"
        }
      },
      "seq": 156,
      "void": false
    },
    {
      "from": null,
      "id": 157,
      "name": "div",
      "parent": 1,
      "props": {
        "children": {
          "type": "code",
          "value": "props.buttonVerify"
        },
        "id": {
          "type": "value",
          "value": "CardPatientInfoREGUX-div-157"
        },
        "style": {
          "type": "code",
          "value": "{ margin: \"0px 15px\" }"
        }
      },
      "seq": 157,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 158,
      "name": "FormGroup",
      "parent": 3,
      "props": {
        "id": {
          "type": "value",
          "value": "CardPatientInfoREGUX-FormGroup-158"
        },
        "inline": {
          "type": "code",
          "value": "true"
        }
      },
      "seq": 95,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 159,
      "name": "FormField",
      "parent": 158,
      "props": {
        "id": {
          "type": "value",
          "value": "CardPatientInfoREGUX-FormField-159"
        },
        "inline": {
          "type": "code",
          "value": "true"
        },
        "width": {
          "type": "code",
          "value": "6"
        }
      },
      "seq": 159,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 160,
      "name": "FormField",
      "parent": 158,
      "props": {
        "id": {
          "type": "value",
          "value": "CardPatientInfoREGUX-FormField-160"
        },
        "inline": {
          "type": "code",
          "value": "true"
        },
        "width": {
          "type": "code",
          "value": "6"
        }
      },
      "seq": 160,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 161,
      "name": "FormField",
      "parent": 158,
      "props": {
        "id": {
          "type": "value",
          "value": "CardPatientInfoREGUX-FormField-161"
        },
        "inline": {
          "type": "code",
          "value": "true"
        },
        "width": {
          "type": "code",
          "value": "4"
        }
      },
      "seq": 161,
      "void": false
    },
    {
      "from": null,
      "id": 171,
      "name": "label",
      "parent": 159,
      "props": {
        "children": {
          "type": "value",
          "value": "ชื่อผู้ติดต่อฉุกเฉิน / Emergency contact *",
          "valueEN": "Emergency contact name / Emergency contact *"
        },
        "id": {
          "type": "value",
          "value": "CardPatientInfoREGUX-label-171"
        },
        "style": {
          "type": "code",
          "value": "{minWidth: \"80px\", maxWidth: \"150px\",fontWeight: \"normal\", color: \"red\"}"
        }
      },
      "seq": 164,
      "void": false
    },
    {
      "from": null,
      "id": 172,
      "name": "label",
      "parent": 160,
      "props": {
        "children": {
          "type": "value",
          "value": "เบอร์โทรผู้ติดต่อ / Phone No. *",
          "valueEN": "Contact Number / Phone No. *"
        },
        "id": {
          "type": "value",
          "value": "CardPatientInfoREGUX-label-172"
        },
        "style": {
          "type": "code",
          "value": "{minWidth: \"100px\", maxWidth: \"100px\",fontWeight: \"normal\", color: \"red\"}"
        }
      },
      "seq": 163,
      "void": false
    },
    {
      "from": null,
      "id": 173,
      "name": "label",
      "parent": 161,
      "props": {
        "children": {
          "type": "value",
          "value": "ความสัมพันธ์ / Relationship",
          "valueEN": "Relationship / Relationship"
        },
        "id": {
          "type": "value",
          "value": "CardPatientInfoREGUX-label-173"
        }
      },
      "seq": 162,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 174,
      "name": "Input",
      "parent": 159,
      "props": {
        "fluid": {
          "type": "code",
          "value": "true"
        },
        "id": {
          "type": "value",
          "value": ""
        },
        "onChange": {
          "type": "code",
          "value": "props.changeProp(\"relative_address.owner_name\")"
        },
        "style": {
          "type": "code",
          "value": "{width: \"100%\"}"
        },
        "value": {
          "type": "code",
          "value": "props.patient?.relative_address?.owner_name"
        }
      },
      "seq": 174,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 175,
      "name": "Input",
      "parent": 160,
      "props": {
        "fluid": {
          "type": "code",
          "value": "true"
        },
        "id": {
          "type": "value",
          "value": ""
        },
        "onChange": {
          "type": "code",
          "value": "props.changeProp(\"relative_address.tel_mobile\")"
        },
        "style": {
          "type": "code",
          "value": "{width: \"100%\"}"
        },
        "value": {
          "type": "code",
          "value": "props.patient?.relative_address?.tel_mobile"
        }
      },
      "seq": 175,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 176,
      "name": "Dropdown",
      "parent": 161,
      "props": {
        "clearable": {
          "type": "code",
          "value": "true"
        },
        "fluid": {
          "type": "code",
          "value": "true"
        },
        "id": {
          "type": "value",
          "value": ""
        },
        "onChange": {
          "type": "code",
          "value": "props.changeProp(\"relative_address.relative\")"
        },
        "options": {
          "type": "code",
          "value": "props.masterOptions?.relative"
        },
        "search": {
          "type": "code",
          "value": "true"
        },
        "selection": {
          "type": "code",
          "value": "true"
        },
        "style": {
          "type": "code",
          "value": "{width: \"100%\"}"
        },
        "value": {
          "type": "code",
          "value": "props.patient?.relative_address?.relative"
        }
      },
      "seq": 176,
      "void": false
    },
    {
      "from": null,
      "id": 177,
      "name": "label",
      "parent": 45,
      "props": {
        "children": {
          "type": "value",
          "value": "Prefix",
          "valueEN": "Prefix"
        },
        "id": {
          "type": "value",
          "value": "CardPatientInfoREGUX-label-177"
        },
        "style": {
          "type": "code",
          "value": "{fontWeight: \"normal\", ...(  (props.patient?.citizen_type !== \"\" && props.patient?.citizen_type !== \"T\") && {  color: \"red\" } )}"
        }
      },
      "seq": 49,
      "void": false
    },
    {
      "from": null,
      "id": 178,
      "name": "label",
      "parent": 46,
      "props": {
        "children": {
          "type": "value",
          "value": "First name",
          "valueEN": "First name"
        },
        "id": {
          "type": "value",
          "value": "CardPatientInfoREGUX-label-178"
        },
        "style": {
          "type": "code",
          "value": "{fontWeight: \"normal\", ...(  (props.patient?.citizen_type !== \"\" && props.patient?.citizen_type !== \"T\") && {  color: \"red\" } )}"
        }
      },
      "seq": 50,
      "void": false
    },
    {
      "from": null,
      "id": 179,
      "name": "label",
      "parent": 47,
      "props": {
        "children": {
          "type": "value",
          "value": "Last name",
          "valueEN": "Last name"
        },
        "id": {
          "type": "value",
          "value": "CardPatientInfoREGUX-label-179"
        },
        "style": {
          "type": "code",
          "value": "{fontWeight: \"normal\", ...(  (props.patient?.citizen_type !== \"\" && props.patient?.citizen_type !== \"T\") && {  color: \"red\" } )}"
        }
      },
      "seq": 51,
      "void": false
    },
    {
      "from": null,
      "id": 180,
      "name": "label",
      "parent": 48,
      "props": {
        "children": {
          "type": "value",
          "value": "Middle name",
          "valueEN": "Middle name"
        },
        "id": {
          "type": "value",
          "value": "CardPatientInfoREGUX-label-180"
        },
        "style": {
          "type": "code",
          "value": "{fontWeight: \"normal\", }"
        }
      },
      "seq": 52,
      "void": false
    },
    {
      "from": null,
      "id": 181,
      "name": "div",
      "parent": 1,
      "props": {
        "children": {
          "type": "code",
          "value": "props.onMergePatientBtn"
        },
        "id": {
          "type": "value",
          "value": "CardPatientInfoREGUX-div-181"
        }
      },
      "seq": 181,
      "void": false
    }
  ],
  "forwardRef": false,
  "height": 95,
  "isMounted": false,
  "memo": false,
  "name": "CardPatientInfoREGUX",
  "project": "IsHealth",
  "screenPropsDefault": {
    "first_name": "ชื่อทดสอบ",
    "last_name": "สกุลทดสอบ",
    "secretOptions": [
      {
        "key": "N",
        "text": "ไม่ปกปิด",
        "value": "N"
      },
      {
        "key": "S",
        "text": "ปกปิดประวัติ",
        "value": "S"
      }
    ]
  },
  "width": 85
}

*********************************************************************************** */
